export default [["en-us", {
  "controls": {
    "future": {
      "placeholder": "Placeholder for future development",
      "q": "Q"
    },
    "schematic-table": {
      "model": {
        "photodiode": {
          "bias": "bias",
          "cd": "cd",
          "circuitName": "circuitName",
          "ip": "ip",
          "rsh": "rsh",
          "vBias": "vBias",
          "vr": "vr"
        },
        "stage1": {
          "bw": "bw",
          "cf": "cf",
          "cin": "cin",
          "opamp": {
            "partNumber": "opAmp"
          },
          "q": "q",
          "rf": "rf",
          "rin": "rin",
          "title": "Stage 1"
        },
        "stage2": {
          "bw": "bw",
          "cfilter": "cfilter",
          "opamp": {
            "partNumber": "opAmp"
          },
          "rf": "rf",
          "rfilter": "rfilter",
          "rg": "rg",
          "title": "Stage 2"
        }
      },
      "title": "Photodiode"
    }
  },
  "current-calculation": {
    "active-area": "Active Area:",
    "cancel": "Cancel",
    "equals": " = ",
    "instruction": "Enter either the peak light intensity or the peak photodiode current:",
    "multiply": " X ",
    "peak-current": "Peak Photodiode Current:",
    "peak-light-intensity": "Peak Light Intensity:",
    "sensitivity": "Sensitivity:",
    "title": "Peak Photodiode Current Calculation",
    "use-this-peak": "Use this Peak Current"
  },
  "dialogs": {
    "download": {
      "error-message": "<p>Unable to get design files. This error may occur for the following reasons:</p><p>1) Broken connection to the server.</p><p>2) Services are down.</p>",
      "error-title": "Download"
    },
    "feedback": {
      "email": "EMail: ",
      "feedback": "Your Feedback",
      "feedback-dialog-ng-message": "Failed to send user feedback. This may be due to a poor connection to the server. Please try again.",
      "feedback-dialog-ok-message": "Your feedback has been sent.",
      "give-feedback": "Tell us",
      "invitation": "Please let us know your opinion of this tool, good and bad.",
      "name": "Name: ",
      "optional": "(Optional)",
      "title": "Give us your feedback!"
    },
    "load": {
      "invalid-file": "Invalid design file. Please verify the contents of the design file you are trying to load.",
      "invalid-parts": "Unable to load design. The following {numParts, plural, =1 {part in this design file is} other {parts in this design file are}} no longer supported by this application: {parts}",
      "no-opamps": "OpAmp data is unavailable. Unable to load design. Try to refresh your browser. If the problem persists, please use Photodiode's feedback button in the upper right to report the issue.",
      "title": "Load Design"
    },
    "samples": {
      "title": "Order Samples"
    },
    "save": {
      "error-message": "Cannot save design. Please check if the data you entered is correct before saving.",
      "error-title": "Save Design"
    },
    "share": {
      "share-dialog-ng-message": "Unable to share design. This is likely due to a server connection error. Please try again.",
      "share-dialog-ok-message": "Design has been shared",
      "title": "Email My Design"
    },
    "system": {
      "application-busy": "Working...",
      "connecting-to": "Connecting to {tool}...",
      "download-create-bom": "Creating BOM File...",
      "download-create-data": "Creating Data Files...",
      "download-create-design": "Creating Design File...",
      "download-create-eval-board": "Creating Eval Board File...",
      "download-create-graph": "Creating Graph Data...",
      "download-create-pdf": "Creating PDF File...",
      "download-create-spice": "Creating SPICE Files...",
      "download-downloading": "Downloading...",
      "download-requesting": "Requesting...",
      "error-config-data": "Configuration data is unavailable. Unable to proceed as Photodiode Specifications cannot be validated properly. Try to refresh your browser. If the problem persists, please use Photodiode's feedback button in the upper right to report the issue.",
      "error-opamp-data": "OpAmp data is unavailable. Photodiode is unable to proceed. Save your design and try to refresh your browser. If the problem persists, please use Photodiode's feedback button in the upper right to report the issue.",
      "error-pst-data": "Data map is temporarily unavailable, and hence the OpAmp table cannot be displayed. Save your design and try to refresh your browser. If the problem persists, please use Photodiode's feedback button in the upper right to report the issue.",
      "error-sensor-data": "Sensor data is temporarily unavailable, and hence the Sensor table cannot be displayed. Save your design and try to refresh your browser. If the problem persists, please use Photodiode's feedback button in the upper right to report the issue.",
      "loading-opamp-data": "Loading OpAmp data...",
      "sending-filter": "Sending filter to {tool}...",
      "title": "Application Message"
    }
  },
  "download": {
    "data-files": {
      "frequency-response": {
        "frequency": "Frequency",
        "magnitude": "Magnitude"
      },
      "noise-gain": {
        "caps": "(Cin + Cf) / Cf",
        "frequency": "Frequency",
        "noise-gain": "Noise Gain",
        "opamp-gain": "Op Amp Gain",
        "zero": "(Cin || Cf) (Rin || Rf) <br/> Zero"
      },
      "pulse-response": {
        "pulse-response": "Pulse Response",
        "time-axis": "Time Axis"
      },
      "spectral-noise": {
        "frequency": "Frequency",
        "opi": "Op Amp I",
        "opi2": "Op Amp 2 I",
        "opv": "Op Amp V",
        "opv2": "Op Amp 2 V",
        "rf": "Rf",
        "rfilter": "Rfilter",
        "rin": "Rin",
        "total": "Total"
      }
    },
    "pdf-content": {
      "pdf-data-fields": {
        "capacitance": "Capacitance (Cd)",
        "one-stage": "One Stage",
        "peak-current": "Peak Current (Ip)",
        "peak-voltage": "Peak Voltage (Vp)",
        "photodiode-bias": "Photodiode Bias",
        "requested-bandwidth": "Requested Bandwidth",
        "reverse-voltage": "Reverse Voltage (Vr)",
        "sensor": "Sensor",
        "shunt-resistance": "Shunt Resistance (Rsh)",
        "stages": "Stage",
        "two-stage": "Two Stages"
      },
      "pdf-data-ie-image-missing": "We are very sorry, but we are unable to generate images if you are using Internet Explorer 8 or below to browse this tool. Please use Firefox, Chrome, or Internet Explorer 9 or above if you would like to see the image on this page.",
      "pdf-desc": "{desc}\n\nCreated by {user} on {date}",
      "pdf-desc-no-design-name": "Created by {user} on {date}",
      "pdf-desc-no-name-desc": "Created on {date}",
      "pdf-desc-no-user-name": "{desc}\n\nCreated on {date}",
      "pdf-heading": "Photodiode Design Report",
      "pdf-page-headers": {
        "bill-of-materials": "Bill of Materials",
        "circuit": "Circuit",
        "frequency-response": "Frequency Response",
        "noise-gain": "Noise Gain",
        "pulse-response": "Pulse Response",
        "snr": "SNR",
        "spectral-noise": "Spectral Noise Density"
      },
      "pdf-subheading": "Design Parameters Entered by User",
      "pdf-tool-name": "Photodiode"
    },
    "spice-files": {
      "message_netlist_readme": "This directory (Spice Files) contains three simulation-ready SPICE netlists.\r\nThese netlists contain the photodiode amplifier design generated by Photodiode \r\nWizard, and the corresponding SPICE macromodels for the selected op amp(s). \r\nAlso included is a suitable input signal, and appropriate analysis mode \r\n(.AC, .TRAN, .NOISE).\r\n\nThese netlists are text-based .cir files, and should be compatible with a wide\r\nvariety of SPICE simulators.  More information about text-based SPICE netlists\r\ncan be found at: http://bwrcs.eecs.berkeley.edu/Classes/IcBook/SPICE/ \r\n\n\t- ACAnalysis.cir: Simulates AC response of the photodiode amplifier design. \r\n\t                  Output of circuit can be plotted by probing V(OUT) \r\n\n\t- TransientAnalysis.cir: Simulates the step response of the photodiode \r\n\t                         amplifier design. Output of circuit can be plotted by \r\n\t                         probing V(OUT) \r\n\n\t- NoiseAnalysis.cir: Simulates the noise of the photodiode amplifier design. \r\n\t                     Noise gain can be plotted by probing GAIN, or \r\n\t                     V(ONOISE)/V(INOISE) \r\n\n\nAny questions about these SPICE netlists, or about Photodiode Wizard in general \r\ncan be submitted at: \r\nhttp://ez.analog.com/community/amplifiers/operational-amplifiers \r\n",
      "message_netlist_readme_filename": "README.txt",
      "message_no_netlist_filename": "Why no netlist files.txt",
      "message_no_schematic": "Now that LTspice is part of Analog Devices, we are converting our SPICE netlists into LTspice models.  The op amps in your design do not currently have LTspice models available.  If you would like ADI to prioritize LTspice model generation for a particular part, please let your sales representative know or send feedback through this tool.\r\n\r\nSPICE simulation supported by parts in your design:\r\n",
      "message_no_schematic_filename": "Why no LTspice.txt",
      "message_no_schematic_no_netlist": "ADI is currently in the process of transitioning our op amps from SPICE netlists to LTspice models.  Your design contains a mixture of parts, where some have text based netlists and some have LTspice files.  Because of this, the tool is not able to generate any SPICE output.  We apologize for the inconvenience and are working on getting this fixed.  If you would like ADI to prioritize LTspice model generation for a particular part, please let your sales representative know or send feedback through this tool.\r\n\r\nSPICE simulation supported by parts in your design:\r\n",
      "message_no_schematic_no_netlist_filename": "README.txt",
      "message_part_no_netlist": "The following parts cannot generate netlist model information.\r\n",
      "message_part_no_spice_info": "The following op amps in your design do not have LTspice models or text netlist models.\r\nIf you would like ADI to prioritize LTspice model generation for a particular part, please let your sales representative know or send feedback through this tool.\r\n",
      "message_part_no_spice_info_filename": "Why no spice files.txt"
    }
  },
  "ember-aditools-page": {
    "card": {
      "checkbox-tooltip": "Toggle",
      "help-tooltip": "Click for help",
      "part-number-tooltip": "Click to select part"
    },
    "common": {
      "cancel": "Cancel",
      "close": "Close",
      "load": "Load",
      "ok": "OK",
      "open": "Open",
      "save": "Save",
      "select": "Select"
    },
    "dialogs": {
      "feedback": {
        "email": "EMail: ",
        "feedback": "Your Feedback",
        "give-feedback": "Tell us",
        "invitation": "Please let us know your opinion of this tool, good and bad.",
        "name": "Name: ",
        "optional": "(Optional)",
        "title": "Give us your feedback!"
      },
      "load": {
        "choose-button": "Choose File",
        "message": "Load a design from a file on your computer.",
        "no-file-selected": "No file selected.",
        "title": "Load Design"
      },
      "samples": {
        "add-button": "Add Selected Samples to Cart",
        "add-link": "Add to Order",
        "add-to-cart-column": "Add Sample to Cart",
        "model-column": "Device Model/Package",
        "part-column": "Device Name",
        "quantities-warning": "Analog Devices offers a limited amount of free samples to qualified customers. Due to the large demand for our product samples we ask that you limit your sample request to 2 pieces per part with a maximum of 4 parts per request within a 14 day time period. Should your design needs require additional product quantities, you can purchase them on the web through Buy Online, or you can contact one of our authorized distributors.",
        "title": "Order Samples",
        "unavailable-message": "Not available for sample"
      },
      "save": {
        "save-desc-error": "Please provide a Description",
        "save-desc-field": "Description",
        "save-name-error": "Please provide a Design Name",
        "save-name-field": "Design Name",
        "title": "Save Design"
      },
      "share": {
        "share-button": "Email",
        "share-design-information": "<p>To share a copy of your design, enter your name into the <b>Sender name</b> field. Then enter the email address of the recipients in the <b>Share design with</b> field.</p><p>The recipients will receive an email from Analog Devices with an attachment containing a ZIP archive of the shared design. All you have to do is extract the design from the ZIP file and upload it using the Load Design functionality of the application</p><p>This process creates a copy of the design for each recipient. If recipients choose to make edits on their copies, it will have no effect on your design you saved to your own computer.</p>",
        "share-dialog-ng-message": "Unable to share design. This is likely due to a server connection error. Please try again.",
        "share-dialog-ok-message": "Design has been shared",
        "share-duplicate-email": "Duplicate emails found",
        "share-email-empty-error": "Please enter an email address",
        "share-email-field": "Share design with",
        "share-email-format-error": "At least one of the email addresses you entered is invalid. Please correct and try again",
        "share-email-placeholder": "Email Address",
        "share-name-error": "Please provide a Design Name",
        "share-name-field": "Design Name",
        "share-sender-error": "Please provide a Sender Name",
        "share-sender-field": "Sender Name",
        "title": "Share My Design"
      },
      "system": {
        "application-busy": "Working...",
        "title": "Application Message"
      }
    },
    "footer": {
      "accessibility": "Accessibility",
      "cookie-settings": "Cookie Settings",
      "copyright-text": "1995 - 2025 Analog Devices, Inc. All Rights Reserved",
      "icp-id": "",
      "legal": "Legal and Risk",
      "privacy-policy": "Privacy Policy",
      "privacy-settings": "Privacy Settings",
      "sitemap": "Sitemap"
    },
    "header": {
      "applications": "Applications",
      "company": "Company",
      "design-center": "Design Center",
      "education": "Education",
      "parametric-search": "Parametric Search",
      "products": "Products",
      "spoken": {
        "homepage": "ADI Home Page",
        "sitelinks": "ADI Site Links"
      },
      "support": "Support"
    },
    "menubar": {
      "chinese": "简体中文",
      "english": "English",
      "help": "Help",
      "japanese": "日本語",
      "load": "Load Design",
      "save": "Save"
    },
    "studio": {
      "adcdriver": "ADC Driver",
      "dacebc": "DAC",
      "diamond": "In Amp",
      "filterwizard": "Analog Filter",
      "noise": "Noise",
      "photodiode": "Photodiode",
      "precisionstudio": "ADI<span class=''service-mark''>℠</span> Precision Studio",
      "signalchaindesigner": "Signal Chain",
      "simdds": "DDS",
      "spoken": {
        "studiolinks": "ADI Precision Studio Links"
      },
      "virteval": "Virtual Eval"
    },
    "toolbar": {
      "actions": "Actions"
    }
  },
  "figures": {
    "bom": {
      "description": "Click on 'Get Design File' to download a zip file that includes a Bill of Materials in tab delimited format.",
      "designator": "Reference Designator",
      "extra-components": {
        "header": "header",
        "jumper": "jumper",
        "sma-jack": "SMA Jack, board edge female",
        "sma-male": "male-male SMA",
        "socket": "socket",
        "test-pin": "Test pin"
      },
      "material": "Material",
      "materials": {
        "tantalum": "tantalum"
      },
      "package": "Package",
      "quantity": "Quantity",
      "title": "BOM",
      "tolerance": "Tolerance",
      "value": "Value"
    },
    "frequency-response": {
      "fn": "f<tspan dy=\"5px\">N</tspan><tspan dy=\"-5px\"> = {fn}Hz</tspan>",
      "hover-graph-legend": {
        "trans-gain": "Transimpedance Gain: ",
        "x-title": "Frequency: ",
        "x-unit": "Hz",
        "y-unit": "dB",
        "y-unit2": "V/A"
      },
      "q": "Q = {q}",
      "title": "Frequency Resp.",
      "tooltip": "Frequency Response",
      "x-title": "Frequency (Hz)",
      "y-title": "Transimpedance Gain ({unit})"
    },
    "noise-gain": {
      "graph-legend": {
        "caps": "(C<sub>in</sub> + C<sub>f</sub>) / C<sub>f</sub>",
        "noise-gain": "Noise Gain",
        "opamp-gain": "Op Amp Gain",
        "x-title": "Frequency",
        "zero": "(C<sub>in</sub> || C<sub>f</sub>) (R<sub>in</sub> || R<sub>f</sub>) <br/> Zero"
      },
      "hover-graph-legend": {
        "caps": "(Cin + Cf) / Cf: ",
        "noise-gain": "Noise Gain: ",
        "opamp-gain": "Op Amp Gain: ",
        "x-title": "Frequency: ",
        "x-unit": "Hz",
        "y-unit": "dB",
        "y-unit2": "V/V",
        "zero": "(Cin || Cf) (Rin || Rf) Zero: "
      },
      "title": "Noise Gain",
      "tooltip": "Noise Gain",
      "x-title": "Frequency (Hz)",
      "y-title": "Gain ({unit})"
    },
    "pulse-response": {
      "hover-graph-legend": {
        "circuit-output": "Circuit Output: ",
        "x-title": "Time: ",
        "x-unit": "s",
        "y-unit": "V"
      },
      "overshoot": "Overshoot = {overshootPercent}%",
      "rise-time": "Rise Time (10% to 90%) = {riseTime}s",
      "title": "Pulse Resp.",
      "tooltip": "Pulse Response",
      "x-title": "Time (s)",
      "y-title": "Circuit Output (V)"
    },
    "schematic": {
      "amp-single-stage-title-1": "TRANSIMPEDANCE",
      "amp-single-stage-title-2": "AMPLIFIER",
      "amp-single-stage-title-3": "",
      "amp-stage-one-title-1": "STAGE 1",
      "amp-stage-one-title-2": "TRANSIMPEDANCE",
      "amp-stage-one-title-3": "AMPLIFIER",
      "amp-stage-two-title-1": "STAGE 2",
      "amp-stage-two-title-2": "ADDITIONAL GAIN",
      "amp-stage-two-title-3": "AND FILTERING",
      "bypass-capacitors": "BYPASS CAPACITORS",
      "equivalent-circuit-tooltip": "Equivalent Circuit",
      "photodiode-model": "Photodiode Model ( {pd} )",
      "photodiode-model-custom": "Custom",
      "photodiode-model-next-steps": "Model: {pd}",
      "photodiode-stage-title-1": "PHOTODIODE",
      "photodiode-stage-title-2": "",
      "spares": "SPARES",
      "supply-voltage-title-1": "SUPPLY VOLTAGE",
      "supply-voltage-title-2": "MIN: ± {minVoltage}V",
      "supply-voltage-title-3": "MAX: ± {maxVoltage}V",
      "supply-voltage-tooltip": "Supply Voltage",
      "title": "Circuit",
      "warning-cf-less-than-1pF": "Warning: The feedback capacitance, Cf, needed for your design is only {feedback}F. At this low level, board capacitance will have a significant effect on the peaking (Q) of this design. The actual value of Cf should be determined empirically with your specific PCB board. Because the value is so low, the tool has not converted the capacitance into a standard value.",
      "warning-gain-greater-than-1-stable": "Warning:  This circuit may not be stable. The {opamp} is stable for noise gains of {gain} or greater. This means (Cd + Cf) / Cf should be larger than {gain}. In the circuit above Cd = {capacitance}F and Cf = {feedback}F, so (Cd + Cf) / Cf = {noise}. Make sure you verify in spice before building.",
      "why-the-spares-tooltip": "Why the Spares?"
    },
    "snr": {
      "enob": "ENOB = {enob} bits",
      "minimum-signal": "Minimum Signal (Noise Floor)",
      "noise-1f-not-modeled": "1/f and tail current noise not modeled.",
      "noise-contributors": "Noise Contributors (V rms)",
      "noise-floor": "Referred to Output: {voltage}V rms",
      "noise-referred-output": "All noise referred to output",
      "opamp-current": "Op Amp Current",
      "opamp-voltage": "Op Amp Voltage",
      "output-voltage": "Output Voltage: {voltage}V",
      "peak-signal": "Peak Signal",
      "photodiode-current": "Photodiode Current: {current}A",
      "photodiode-current-rms": "Referred to Input: {current}A rms",
      "rf": "R<sub>F</sub>",
      "rfilter": "R<sub>FILTER</sub>",
      "rg": "R<sub>G</sub>",
      "rin": "R<sub>IN</sub>",
      "snr": "SNR = {snr} dB",
      "stage-1": "Stage 1",
      "stage-1-total": "Stage 1 Total",
      "stage-2": "Stage 2",
      "stage-2-total": "Stage 2 Total",
      "title": "SNR",
      "tooltip": "SNR/Dynamic Range",
      "total": "Total",
      "total-noise": "Total Noise: {noise}V rms"
    },
    "spectral-noise": {
      "graph-legend": {
        "opi": "Op Amp I",
        "opi2": "Op Amp 2 I",
        "opv": "Op Amp V",
        "opv2": "Op Amp 2 V",
        "rf": "R<sub>f</sub>",
        "rfilter": "R<sub>filter</sub>",
        "rin": "R<sub>in</sub>",
        "total": "Total",
        "x-title": "Frequency"
      },
      "hover-graph-legend": {
        "opi": "Op Amp I: ",
        "opi2": "Op Amp 2 I: ",
        "opv": "Op Amp V: ",
        "opv2": "Op Amp 2 V: ",
        "rf": "Rf: ",
        "rfilter": "Rfilter: ",
        "rin": "Rin: ",
        "total": "Total: ",
        "x-title": "Frequency: ",
        "x-unit": "Hz",
        "y-unit": "V/√Hz"
      },
      "title": "Spectral Noise",
      "tooltip": "Spectral Noise Density",
      "x-title": "Frequency (Hz)",
      "y-title": "Spectral Noise (V/√Hz)"
    }
  },
  "help": {
    "bias-polarity": {
      "title": "Photodiode Bias"
    },
    "circuit-peaking": {
      "title": "Output Signal: Peaking"
    },
    "circuit-stages": {
      "title": "Stages"
    },
    "dynamic-range": {
      "title": "SNR/Dynamic Range"
    },
    "equivalent-circuit": {
      "title": "Photodiode Equivalent Circuit"
    },
    "frequency-response": {
      "title": "Frequency Response"
    },
    "main-help": {
      "title": "Photodiode Circuit Design Wizard Help"
    },
    "noise-gain": {
      "title": "Noise Gain"
    },
    "opamp": {
      "title": "Op Amp"
    },
    "peak-current": {
      "title": "Photodiode Specs: Peak Current"
    },
    "peak-voltage": {
      "title": "Output Signal: Peak Voltage"
    },
    "photodiode-capacitance": {
      "title": "Photodiode Specs: Capacitance (C<sub>D</sub>)"
    },
    "pulse-response": {
      "title": "Pulse Response"
    },
    "quick-results": {
      "title": "Quick Results"
    },
    "reverse-voltage": {
      "title": "Photodiode Bias: Reverse Voltage (V<sub>R</sub>)"
    },
    "shunt-resistance": {
      "title": "Photodiode Specs: Shunt Resistance (R<sub>SH</sub>)"
    },
    "spectral-noise-density": {
      "title": "Spectral Noise Density"
    },
    "stability": {
      "title": "Stability"
    },
    "supply-voltage": {
      "title": "Supply Voltage"
    },
    "target-speed": {
      "title": "Output Signal: Speed"
    },
    "why-the-spares": {
      "title": "Why the spares?"
    }
  },
  "main": {
    "busy": "Working...",
    "next-tab": "Next Tab",
    "previous-tab": "Previous Tab",
    "title": "Photodiode Circuit Design Wizard"
  },
  "marginal-design": {
    "button": "Show marginal design",
    "message": "To create a robust design, we recommend adjusting your design parameters as described above. However if that is not possible, we were able to find an op amp that might work. The tool has identified the following issues with this design: "
  },
  "menu": {
    "links": {
      "feedback": "Feedback",
      "help": "Help",
      "load": "Load",
      "save": "Save"
    },
    "tabs": {
      "circuit-design": "Circuit Design",
      "next-steps": "Next Steps",
      "photodiode": "Photodiode"
    }
  },
  "model-error": {
    "amp_status_bias_current_is": "high output offset (bias current is {data})",
    "amp_status_big_2nd_stage_gain": "Requires 2nd stage gain of {data}",
    "amp_status_cf_less_100fF": "Cf < 0.1pF",
    "amp_status_cf_less_50fF": "Cf < 50fF",
    "amp_status_cfb_no_cf": "Current feedback amp can't support cap in feedback path",
    "amp_status_cfb_rf_too_small": "unable to drive Rf",
    "amp_status_dB_error": "database error - part data incorrect in database",
    "amp_status_gbw_less_than_bandwith_requested": "Op Amp GBW less than bandwidth requested ",
    "amp_status_high_vos": "high output offset (input Vos is {data})",
    "amp_status_internal_cf_too_high": "internal feedback capacitance too high",
    "amp_status_min_stable_gain": "min stable gain = {data}",
    "amp_status_not_enough_peaking": "can't create enough peaking",
    "amp_status_not_fast_enough": "not fast enough",
    "amp_status_quad": "quad",
    "amp_status_slew_rate_low": "slew rate too low",
    "amp_status_slew_rate_marginal": "slew rate marginal",
    "amp_status_specialty_amp": "specialty amplifier",
    "amp_status_too_fast": "fast amp = lower SNR",
    "amp_status_voltage_not_enough": "voltage range not enough for peak output voltage",
    "amp_status_zero_drift": "zero drift",
    "fixed_op_amp_no_good": "The {partName} is not able to meet the design requirements.  Please choose another op amp or unlock the op amp to have the program choose for you.  <br/><br/>Reason {partName} is unsuitable:",
    "internal_cf_too_high": "The {partName} has {cfint}F of internal feedback capacitance. So what would normally be {cf}F of feedback capacitance for a standard amp is {cfext}F for the {partName}.  <br/><br/>Reason {partName} is unsuitable:",
    "no_op_amps_available_for_first_stage_too_fast": "<p>Unable to recommend an op amp that can meet design requirements for the first stage.</p><p>Things to try: <ul><li>Reduce speed requirements</li><li>Reduce photodiode capacitance</li><li>Reduce peak output voltage</li><li>Increase photodiode peak current</li></ul></p>",
    "no_op_amps_available_for_first_stage_too_slow": "<p>Unable to recommend an op amp that can meet design requirements for the first stage.</p><p>Things to try: <ul><li>Increase speed requirements</li><li>Increase photodiode capacitance</li><li>Increase peak output voltage</li><li>Decrease photodiode peak current</li></ul></p>",
    "no_op_amps_available_for_second_stage": "<p>Unable to recommend an op amp that can meet design requirements for the second stage.</p><p>Solutions: <ul><li>Reduce speed requirements</li><li>Reduce peak output voltage</li></ul></p>",
    "no_op_amps_available_for_single_stage_too_fast": "<p>Unable to recommend an op amp that meets these design requirements.</p><p>Things to try: <ul><li>Choose 2 stage solution</li><li>Reduce speed requirements</li><li>Reduce photodiode capacitance</li><li>Reduce peak output voltage</li><li>Increase photodiode peak current</li></ul></p>",
    "no_op_amps_available_for_single_stage_too_slow": "<p>Unable to recommend an op amp that meets these design requirements.</p><p>Things to try: <ul><li>Increase speed requirements</li><li>Increase photodiode capacitance</li><li>Increase peak output voltage</li><li>Decrease photodiode peak current</li></ul></p>",
    "peak_light_error": "The peak current you provided does not fall in the accepted range ({min} - {max}). Please update the value.",
    "peak_photodiode_error": "The resulting peak current does not fall in the accepted range ({min} - {max}).",
    "rf_too_high": "<p>Gain required is too high for a single stage amplifier configuration.</p><p>Solutions:<ul><li>Choose 2 stage solution</li><li>Reduce peak output voltage</li><li>Increase photodiode peak current</li></ul></p>"
  },
  "opamp-selection": {
    "GBW": "GBW",
    "cancel": "Cancel",
    "comment-drop-down": {
      "message": {
        "amp_status_bias_current_is": "high output offset (bias current is {value}A)",
        "amp_status_big_2nd_stage_gain": "Requires 2nd stage gain of {value}",
        "amp_status_cf_less_100fF": "Cf < 0.1pF",
        "amp_status_cf_less_50fF": "Cf < 50fF",
        "amp_status_cfb_no_cf": "Current feedback amp can't support cap in feedback path",
        "amp_status_cfb_rf_too_small": "unable to drive Rf",
        "amp_status_dB_error": "database error - part data incorrect in database",
        "amp_status_gbw_less_than_bandwith_requested": "Op Amp GBW less than bandwidth requested ",
        "amp_status_high_vos": "high output offset (input Vos is {value}V) ",
        "amp_status_internal_cf_too_high": "internal feedback capacitance too high",
        "amp_status_last_time_buy": "Last Time Buy",
        "amp_status_min_stable_gain": "min stable gain = {value}",
        "amp_status_not_allowed": "not allowed:",
        "amp_status_not_enough_peaking": "can't create enough peaking",
        "amp_status_not_fast_enough": "not fast enough",
        "amp_status_not_recommended": "not recommended:",
        "amp_status_not_recommended_for_new_designs": "not recommended for new designs",
        "amp_status_obsolete": "Obsolete",
        "amp_status_quad": "quad",
        "amp_status_recommended": "recommended",
        "amp_status_slew_rate_low": "slew rate too low",
        "amp_status_slew_rate_marginal": "slew rate marginal",
        "amp_status_specialty_amp": "specialty amplifier",
        "amp_status_too_fast": "fast amp = lower SNR",
        "amp_status_voltage_not_enough": "voltage range not enough for peak output voltage",
        "amp_status_zero_drift": "zero drift"
      },
      "not-allowed": "Not Allowed",
      "not-allowed-match": "not allowed",
      "not-recommended": "Not Recommended",
      "not-recommended-match": "not recommended",
      "recommended": "Recommended",
      "recommended-match": "recommended",
      "show-all": "Show all"
    },
    "comments": "Comments",
    "part-label": "Part",
    "row-count": "'{count, plural, =0 {Displaying # of {total} op amps. Please check the filters provided.} other {Displaying # of {total} op amps.}}'",
    "select": "Select",
    "spice-drop-down": {
      "no": "No",
      "show-all": "Show all",
      "yes": "Yes"
    },
    "status-drop-down": {
      "not-recommended": "Not Recommended for New Designs",
      "not-recommended-match": "Not Recommended for New Designs",
      "production": "Production",
      "production-match": "Production",
      "recommended": "Recommended for New Designs",
      "recommended-match": "Recommended for New Designs",
      "show-all": "Show all"
    },
    "supply-max": "Supply Max",
    "supply-min": "Supply Min",
    "temp-range": "Temperature Range",
    "title": "Choose Op Amp"
  },
  "parameter-selector": {
    "choose-parameters": "Choose Parameters",
    "ok": "OK"
  },
  "sensor-selection": {
    "active-area": "Active Area",
    "cancel": "Cancel",
    "capacitance": "Capacitance",
    "dark-current": "Dark Current",
    "manufacturer": "Manufacturer",
    "operating-temperature": "Operating Temperature",
    "package": "Package",
    "part-number": "Part Number",
    "product-page": "Home Page",
    "resistance": "Resistance",
    "response-time": "Response Time",
    "reverse-breakdown": "Reverse Breakdown",
    "row-count": "'{count, plural, =0 {Displaying # of {total} sensors. Please check the filters provided.} other {Displaying # of {total} sensors.}}'",
    "select": "Select",
    "sensitivity": "Sensitivity",
    "spectral-peak": "Spectral Peak",
    "spectral-range": "Spectral Range",
    "spice": "SPICE",
    "spice-file": "Spice&nbsp;File",
    "title": "Please Select A Sensor",
    "vendor-link": "Vendor&nbsp;Link",
    "viewing-angle": "Viewing Angle"
  },
  "settings": {
    "circuit-design": {
      "enob": "ENOB: {enob} bits",
      "one-stage": "One Stage",
      "opamp-lock": "Lock",
      "opamp-stage1": "Stage 1:",
      "opamp-stage2": "Stage 2:",
      "opamps": "Op Amps:",
      "opamps-tooltip": "Op Amp",
      "output-offset": "Output Offset: {offset}V",
      "output-signal": "Output Signal",
      "peak-voltage": "Peak Voltage (V<sub>P</sub>)",
      "peak-voltage-tooltip": "Peak Voltage",
      "peaking": "Peaking",
      "peaking-high": "high",
      "peaking-low": "low",
      "peaking-tooltip": "Peaking",
      "quick-results": "Quick Results",
      "quick-results-tooltip": "Quick Results",
      "snr": "SNR: {snr} dB",
      "stages": "Stages",
      "stages-tooltip": "Stages",
      "target-bandwidth": "Target Bandwidth",
      "target-option-band": "Bandwidth",
      "target-option-pulse": "Pulse Width",
      "target-pulse-width": "Target Pulse Width",
      "target-speed-tooltip": "Speed",
      "two-stage": "Two Stages"
    },
    "next-steps": {
      "get-files": "Get Files",
      "get-files-all": "All Files",
      "get-files-all-tooltip": "Download zip file containing SPICE files, BOM, and pdf versions of views",
      "get-files-spice": "SPICE Only",
      "get-files-spice-tooltip": "Download zip file containing schematic files",
      "mail": "Mail to Colleague",
      "mail-tooltip": "Send a copy of this design to a colleague",
      "order": "Order",
      "order-samples": "Order Samples",
      "order-samples-tooltip": "Order component sample",
      "share": "Share"
    },
    "photodiode": {
      "bias-polarity-tooltip": "Photodiode Bias",
      "capacitance-1": "Capacitance (C<sub>D</sub>)",
      "capacitance-2": "at V<sub>R</sub> = {vr} V",
      "capacitance-tooltip": "Capacitance",
      "capacitance-warning": "Be careful. This is the capacitance at <u>your</u> reverse voltage, which may be different than what is specified in the datasheet table. You may need to read this value from a datasheet graph instead.",
      "or": "or",
      "peak-current": "Peak Current (I<sub>P</sub>)",
      "peak-current-tooltip": "Peak Current",
      "photodiode-bias": "Photodiode Bias",
      "photodiode-select": "Select Photodiode From Library",
      "photodiode-specs": "Photodiode Specs",
      "reverse-voltage": "Reverse Voltage (V<sub>R</sub>)",
      "reverse-voltage-negative": "Negative",
      "reverse-voltage-positive": "Positive",
      "reverse-voltage-tooltip": "Reverse Voltage",
      "shunt-resistance": "Shunt Resistance (R<sub>SH</sub>)",
      "shunt-resistance-tooltip": "Shunt Resistance"
    }
  },
  "units": {
    "A": "A",
    "F": "F",
    "Q": "Q",
    "R": "Ω",
    "V": "V",
    "active-area": "mm<sup>2</sup>",
    "dB": "dB",
    "farad": "F",
    "hertz": "Hz",
    "meters": "m",
    "ohm": "Ohm",
    "operating-temperature": "&deg;C",
    "peak-light-intensity": " W/m'<sup>2</sup>",
    "seconds": "s",
    "sensitivity": "A/W",
    "unit-price": "$ US",
    "viewing-angle": "&deg;",
    "volts-per-amp": "V/A",
    "volts-per-volt": "V/V"
  },
  "validation-error": {
    "button-tooltip": "Please correct error before continuing",
    "capacitance": "Capacitance Value must be in range: {min} to {max}",
    "invalid-input-error": "The value \"{value}\" in field {field} cannot be parsed.",
    "min-pulse-speed": "Speed Value must be in range: {min} to {max}",
    "no-opamp-found": "None found",
    "peak-current": "Peak Current Value must be in range: {min} to {max}",
    "peak-light-intensity": "Peak Light Intensity must be in range: {min} to {max}",
    "peak-voltage": "Peak Voltage Value must be in range: {min} to {max}",
    "reverse-voltage": "Reverse Voltage value must be in range: {min} to {max}",
    "shunt-resistance": "Shunt Resistance Value  must be in range: {min} to {max}",
    "speed": "Speed Value must be in range: {min} to {max}"
  }
}], ["ja-jp", {
  "controls": {
    "future": {
      "placeholder": "将来の開発のためのプレースホルダー",
      "q": "Q"
    },
    "schematic-table": {
      "model": {
        "photodiode": {
          "bias": "バイアス",
          "cd": "CD",
          "circuitName": "回路名",
          "ip": "IP",
          "rsh": "rsh",
          "vBias": "vバイアス",
          "vr": "vr"
        },
        "stage1": {
          "bw": "bw",
          "cf": "cf",
          "cin": "シン",
          "opamp": {
            "partNumber": "オペアンプ"
          },
          "q": "q",
          "rf": "rf",
          "rin": "リン",
          "title": "ステージ1"
        },
        "stage2": {
          "bw": "bw",
          "cfilter": "cfilter",
          "opamp": {
            "partNumber": "opAmp"
          },
          "rf": "rf",
          "rfilter": "rfilter",
          "rg": "rg",
          "title": "Stage 2"
        }
      },
      "title": "フォトダイオード"
    }
  },
  "current-calculation": {
    "active-area": "アクティブ領域:",
    "cancel": "キャンセル",
    "equals": " = ",
    "instruction": "ピーク光度あるいはピーク・フォトダイオード電流を入力してください：",
    "multiply": " X ",
    "peak-current": "ピーク・フォトダイオード電流:",
    "peak-light-intensity": "光量のピーク強度:",
    "sensitivity": "感度:",
    "title": "ピーク・フォトダイオード電流の計算",
    "use-this-peak": "このピーク電流を使用します"
  },
  "dialogs": {
    "download": {
      "error-message": "<p>設計ファイルを取得できません。 このエラーは、以下の理由で発生している場合があります。</ p> <p> 1）サーバとの接続が切れているため。</ p> <p> 2）サービスが停止されているため。",
      "error-title": "ダウンロード"
    },
    "feedback": {
      "email": "お客様のメールアドレス：",
      "feedback": "ご意見、ご要望：",
      "feedback-dialog-ng-message": "フィードバックの送信に失敗しました。ネットワーク接続に問題がある場合があります。お手数ですが再度お試しください。",
      "feedback-dialog-ok-message": "ご意見、ご要望をご記入頂きありがとうございました。",
      "give-feedback": "意見または感想を送る",
      "invitation": "このツールに関する率直なご意見、ご要望をお聞かせください。 ",
      "name": "お客様のお名前：",
      "optional": "(Optional)",
      "title": "皆様のご意見をお聞かせください！"
    },
    "load": {
      "invalid-file": "有効でない設計ファイルです。ファイルをご確認ください。",
      "invalid-parts": "{numParts,plural,other{設計を読み込めません。この設計で使用されている次の部品は、このアプリケーションではサポートされていません： }}{parts}",
      "no-opamps": "オペアンプのデータが入手できません。設計を読み込むことができません。ブラウザを更新してみてください。引き続きこの問題が発生する場合は、フォトダイオード回路設計ウィザードの右上部にある［ご意見・ご要望］ボタンで問題をご報告ください。",
      "title": "設計を読み込む"
    },
    "samples": {
      "title": "サンプル注文"
    },
    "save": {
      "error-message": "デザインを保存できません。入力したデータが正しいか確認してから保存してください。",
      "error-title": "デザインを保存"
    },
    "share": {
      "share-dialog-ng-message": "回路を共有できません。サーバーの接続不良による可能性があります。再度お試しください。",
      "share-dialog-ok-message": "回路は共有されました",
      "title": "自分の設計をメールで送信"
    },
    "system": {
      "application-busy": "処理中・・・",
      "connecting-to": "Connecting to {tool}...",
      "download-create-bom": "BOM ファイルを作成中・・・",
      "download-create-data": "データ・ファイルを作成中・・・",
      "download-create-design": "設計ファイルの作成中・・・",
      "download-create-eval-board": "評価用ボード・ファイルを作成中・・・",
      "download-create-graph": "Graph データを作成中・・・",
      "download-create-pdf": "PDFファイルを作成中・・・",
      "download-create-spice": "SPICEファイルを作成中・・・",
      "download-downloading": "ダウンロード中・・・",
      "download-requesting": "送信中・・・",
      "error-config-data": "構成データが入手できません。フォトダイオードの仕様を正しく検証できないため続行できません。ブラウザを更新してみてください。引き続きこの問題が発生する場合は、フォトダイオード回路設計ウィザードの右上部にある［ご意見・ご要望］ボタンで問題をご報告ください。",
      "error-opamp-data": "オペアンプのデータが入手できません。フォトダイオード回路設計ウィザードを続行できません。設計を保存しブラウザを更新してみてください。引き続きこの問題が発生する場合は、フォトダイオード回路設計ウィザードの右上部にある［ご意見・ご要望］ボタンで問題をご報告ください。",
      "error-pst-data": "現在データ・マップが入手できません。そのため、オペアンプ・テーブルを表示できません。設計を保存しブラウザを更新してみてください。引き続きこの問題が発生する場合は、フォトダイオード回路設計ウィザードの右上部にある［ご意見・ご要望］ボタンで問題をご報告ください。",
      "error-sensor-data": "現在センサー・データが入手できません。そのため、センサー・テーブルを表示できません。設計を保存しブラウザを更新してみてください。引き続きこの問題が発生する場合は、フォトダイオード回路設計ウィザードの右上部にある［ご意見・ご要望］ボタンで問題をご報告ください。",
      "loading-opamp-data": "オペアンプ・データ読み込み中...",
      "sending-filter": "Sending filter to {tool}...",
      "title": "アプリケーション・メッセージ"
    }
  },
  "download": {
    "data-files": {
      "frequency-response": {
        "frequency": "周波数",
        "magnitude": "振幅"
      },
      "noise-gain": {
        "caps": "(Cin + Cf) / Cf",
        "frequency": "周波数",
        "noise-gain": "ノイズゲイン",
        "opamp-gain": "オペアンプ・ゲイン",
        "zero": "(Cin || Cf) (Rin || Rf) <br/> Zero"
      },
      "pulse-response": {
        "pulse-response": "パルス応答",
        "time-axis": "時間軸"
      },
      "spectral-noise": {
        "frequency": "周波数",
        "opi": "Op Amp I",
        "opi2": "Op Amp 2 I",
        "opv": "Op Amp V",
        "opv2": "Op Amp 2 V",
        "rf": "Rf",
        "rfilter": "Rfilter",
        "rin": "Rin",
        "total": "Total"
      }
    },
    "pdf-content": {
      "pdf-data-fields": {
        "capacitance": "静電容量 (Cd)",
        "one-stage": "1ステージ",
        "peak-current": "ピーク電流 (Ip)",
        "peak-voltage": "ピーク電圧 (Vp)",
        "photodiode-bias": "フォトダイオードのバイアス電圧",
        "requested-bandwidth": "希望する帯域",
        "reverse-voltage": "逆電圧 (Vr)",
        "sensor": "センサー",
        "shunt-resistance": "フォトダイオードのシャント抵抗 (Rsh)",
        "stages": "段",
        "two-stage": "2ステージ"
      },
      "pdf-data-ie-image-missing": "大変申し訳ありませんが、このツールをExplorer 8　またはそれ以下のバージョンでお使いの場合、画像を表示することができません。Firefox,Chrome,または　Explorer 9をお使いください。",
      "pdf-desc": "{desc}\n\n作成者 {user} 作成日 {date}",
      "pdf-desc-no-design-name": "作成者 {user} 作成日{date}",
      "pdf-desc-no-name-desc": "作成日{date}",
      "pdf-desc-no-user-name": "{desc}\n\n作成日 {date}",
      "pdf-heading": "フォトダイオード・デザイン・レポート",
      "pdf-page-headers": {
        "bill-of-materials": "部品表",
        "circuit": "回路",
        "frequency-response": "周波数応答",
        "noise-gain": "ノイズ・ゲイン",
        "pulse-response": "パルス応答",
        "snr": "SNR",
        "spectral-noise": "スペクトル・ノイズ密度"
      },
      "pdf-subheading": "フォトダイオードの特性と部品",
      "pdf-tool-name": "フォトダイオード"
    },
    "spice-files": {
      "message_netlist_readme": "This directory (Spice Files) contains three simulation-ready SPICE netlists.\r\nThese netlists contain the photodiode amplifier design generated by Photodiode \r\nWizard, and the corresponding SPICE macromodels for the selected op amp(s). \r\nAlso included is a suitable input signal, and appropriate analysis mode \r\n(.AC, .TRAN, .NOISE).\r\n\nThese netlists are text-based .cir files, and should be compatible with a wide\r\nvariety of SPICE simulators.  More information about text-based SPICE netlists\r\ncan be found at: http://bwrcs.eecs.berkeley.edu/Classes/IcBook/SPICE/ \r\n\n\t- ACAnalysis.cir: Simulates AC response of the photodiode amplifier design. \r\n\t                  Output of circuit can be plotted by probing V(OUT) \r\n\n\t- TransientAnalysis.cir: Simulates the step response of the photodiode \r\n\t                         amplifier design. Output of circuit can be plotted by \r\n\t                         probing V(OUT) \r\n\n\t- NoiseAnalysis.cir: Simulates the noise of the photodiode amplifier design. \r\n\t                     Noise gain can be plotted by probing GAIN, or \r\n\t                     V(ONOISE)/V(INOISE) \r\n\n\nAny questions about these SPICE netlists, or about Photodiode Wizard in general \r\ncan be submitted at: \r\nhttp://ez.analog.com/community/amplifiers/operational-amplifiers \r\n",
      "message_netlist_readme_filename": "README.txt",
      "message_no_netlist_filename": "Why no netlist files.txt",
      "message_no_schematic": "現在、LTspiceはアナログ・デバイセズのツールとなり、SPICEネットリストをLTspiceモデルに変換しております。残念ながら、お客様の設計で使用しているオペアンプ製品は、現在LTspiceでは使用できません。特定の製品をLTspiceで使用されることをご希望の場合には、営業担当者にご連絡いただくか、このツールのフィードバック機能よりご意見をお送りください。\r\n\r\nSPICEシュミレーション・ツールでのサポート済み製品:\r\n",
      "message_no_schematic_filename": "Why no LTspice.txt",
      "message_no_schematic_no_netlist": "アナログ･デバイセズは、現在SPICE ネットリストのオペアンプ製品をLTspiceにてご使用いただけるよう移行を行っております。お客様の設計にはLTspiceで使用できるものと使用できないものがあり、このツールではSPICE用ファイルを作成することが出来ません。ご不便をお掛けしておりますこと、お詫び申し上げます。特定の製品をLTspiceで使用されることをご希望の場合には、営業担当者にご連絡いただくか、このツールのフィードバック機能よりご意見を頂きますようお願い申し上げます。\r\n\r\nSPICEシュミレーション・ツールでのサポート済み製品:\r\n",
      "message_no_schematic_no_netlist_filename": "README.txt",
      "message_part_no_netlist": "以下の部分は、ネットリストモデル情報を生成できません。\r\n",
      "message_part_no_spice_info": "The following op amps in your design do not have LTspice models or text netlist models.\r\nIf you would like ADI to prioritize LTspice model generation for a particular part, please let your sales representative know or send feedback through this tool.\r\n",
      "message_part_no_spice_info_filename": "Why no spice files.txt"
    }
  },
  "ember-aditools-page": {
    "card": {
      "checkbox-tooltip": "Toggle",
      "help-tooltip": "Click for help",
      "part-number-tooltip": "Click to select part"
    },
    "common": {
      "cancel": "キャンセル",
      "close": "閉じる",
      "load": "読み込む",
      "ok": "OK",
      "open": "開く",
      "save": "保存する",
      "select": "選ぶ"
    },
    "dialogs": {
      "feedback": {
        "email": "お客様のメールアドレス：",
        "feedback": "ご意見、ご要望：",
        "give-feedback": "意見または感想を送る",
        "invitation": "このツールに関する率直なご意見、ご要望をお聞かせください。 ",
        "name": "お客様のお名前：",
        "optional": "(Optional)",
        "title": "皆様のご意見をお聞かせください！"
      },
      "load": {
        "choose-button": "ファイルを選択",
        "message": "ローカルPC上の設計ファイルを読み込む",
        "no-file-selected": "No file selected.",
        "title": "設計を読み込む"
      },
      "samples": {
        "add-button": "選択したサンプルをカートに入れる",
        "add-link": "Add to Order",
        "add-to-cart-column": "サンプルをカートに入れる",
        "model-column": "モデル／パッケージ",
        "part-column": "構成部品",
        "quantities-warning": "アナログ・デバイセズは認証させていただいたお客様に限り、無料サンプルのご注文を受け付けています。 サンプルについては大変多くのご要望をいただいておりますため、おひとり様2週間あたり最大で4製品、各2個ずつまでのご注文とさせていただきます。無料サンプルとしてご注文いただける以上の量が必要な場合は、オンライン購入をしていただくか（在庫がある場合に限ります）、販売代理店にお問い合わせください。",
        "title": "サンプル注文",
        "unavailable-message": "サンプルの提供はありません。"
      },
      "save": {
        "save-desc-error": "概要を入力してください。",
        "save-desc-field": "概要",
        "save-name-error": "デザイン名を入力してください。",
        "save-name-field": "デザイン名",
        "title": "保存"
      },
      "share": {
        "share-button": "Email",
        "share-design-information": "<p>設計ファイルのコピーを共有するには、<b>“差出人名”</b>にお客様のお名前を、共有したい方のメールアドレスを<b>“設計を共有”</b>項目にご入力ください。送信先が複数の場合には、それぞれのメールアドレスを改行してご入力ください。</p><p>アナログ･デバイセズよりZIPファイルにまとめられた設計ファイルが添付されたメールを、ご入力いただいたメールアドレスにお送りします。添付されたZIPファイルを解凍して、各ツールのアップロード機能を使用して設計ファイルをアップロードするだけで、その設計ファイルを使用することが出来ます。</p><p>上記手順により、共有された設計ファイルのコピーを使用することが出来ます。ただし、共有された設計ファイルのコピーが編集されても、お客様のオリジナルの設計ファイルが編集されることはありません。</p>",
        "share-dialog-ng-message": "回路を共有できません。サーバーの接続不良による可能性があります。再度お試しください。",
        "share-dialog-ok-message": "回路は共有されました",
        "share-duplicate-email": "同じメールアドレスが複数含まれています",
        "share-email-empty-error": "メールアドレスを入力してください。",
        "share-email-field": "設計を共有",
        "share-email-format-error": "お客様が入力したメールアドレスの中で少なくとも１つは無効です。修正して再度お試しください。",
        "share-email-placeholder": "メールアドレス",
        "share-name-error": "デザイン名を入力してください。",
        "share-name-field": "デザイン名",
        "share-sender-error": "差出人名を入力してください。",
        "share-sender-field": "差出人名",
        "title": "自分の設計をメールで送信"
      },
      "system": {
        "application-busy": "処理中・・・",
        "title": "アプリケーション・メッセージ"
      }
    },
    "footer": {
      "accessibility": "アクセシビリティ",
      "cookie-settings": "Cookieの設定",
      "copyright-text": "1995 - 2025 Analog Devices, Inc. 全著作権所有",
      "icp-id": "",
      "legal": "法的事項およびリスク約",
      "privacy-policy": "プライバシーポリシー",
      "privacy-settings": "プライバシー設定",
      "sitemap": "サイトマップ"
    },
    "header": {
      "applications": "アプリケーション",
      "company": "企業情報",
      "design-center": "設計支援",
      "education": "調べる／学ぶ",
      "parametric-search": "パラメータ検索",
      "products": "製品",
      "spoken": {
        "homepage": "ホームページ",
        "sitelinks": "アナログ・デバイセズのサイトへのリンク"
      },
      "support": "サポート"
    },
    "menubar": {
      "chinese": "简体中文",
      "english": "English",
      "help": "ヘルプ",
      "japanese": "日本語",
      "load": "設計を読み込む",
      "save": "保存"
    },
    "studio": {
      "adcdriver": "ADCドライバ",
      "dacebc": "DAC",
      "diamond": "計装アンプ",
      "filterwizard": "アナログ・フィルタ",
      "noise": "ノイズ",
      "photodiode": "フォトダイオード",
      "precisionstudio": "ADI<span class=''service-mark''>℠</span> Precision Studio",
      "signalchaindesigner": "Signal Chain",
      "simdds": "DDS",
      "spoken": {
        "studiolinks": "ADI Precision Studio へのリンク"
      },
      "virteval": "Virtual Eval"
    },
    "toolbar": {
      "actions": "Actions"
    }
  },
  "figures": {
    "bom": {
      "description": "「設計用ファイル」のボタンをクリックすると、テキストファイル形式のBOMのzipファイルをダウンロードできます。",
      "designator": "リファレンス・デジグネーター",
      "extra-components": {
        "header": "ヘッダ",
        "jumper": "ジャンパ",
        "sma-jack": "SMAジャック、ボード・エッジ、メス",
        "sma-male": "オス-オスSMA",
        "socket": "ソケット",
        "test-pin": "テスト・ピン"
      },
      "material": "材料",
      "materials": {
        "tantalum": "タンタル"
      },
      "package": "パッケージ",
      "quantity": "量",
      "title": "部品リスト（BOM）",
      "tolerance": "許容誤差",
      "value": "値"
    },
    "frequency-response": {
      "fn": "f<tspan dy=\"5px\">N</tspan><tspan dy=\"-5px\"> = {fn}Hz</tspan>",
      "hover-graph-legend": {
        "trans-gain": "トランスインピーダンス・ゲイン: ",
        "x-title": "周波数: ",
        "x-unit": "Hz",
        "y-unit": "dB",
        "y-unit2": "V/A"
      },
      "q": "Q = {q}",
      "title": "周波数応答",
      "tooltip": "Frequency Response",
      "x-title": "周波数（Hz)",
      "y-title": "トランスインピーダンス・ゲイン（{unit}）"
    },
    "noise-gain": {
      "graph-legend": {
        "caps": "(C<sub>in</sub> + C<sub>f</sub>) / C<sub>f</sub>",
        "noise-gain": "ノイズゲイン",
        "opamp-gain": "オペアンプ・ゲイン",
        "x-title": "周波数",
        "zero": "(C<sub>in</sub> || C<sub>f</sub>) (R<sub>in</sub> || R<sub>f</sub>) <br/> Zero"
      },
      "hover-graph-legend": {
        "caps": "(Cin + Cf) / Cf: ",
        "noise-gain": "ノイズゲイン: ",
        "opamp-gain": "オペアンプ・ゲイン: ",
        "x-title": "周波数: ",
        "x-unit": "Hz",
        "y-unit": "dB",
        "y-unit2": "V/V",
        "zero": "(Cin || Cf) (Rin || Rf) Zero: "
      },
      "title": "ノイズ・ゲイン",
      "tooltip": "ノイズ・ゲイン",
      "x-title": "周波数（Hz)",
      "y-title": "ゲイン（{unit}）"
    },
    "pulse-response": {
      "hover-graph-legend": {
        "circuit-output": "回路出力: ",
        "x-title": "時間: ",
        "x-unit": "秒",
        "y-unit": "V"
      },
      "overshoot": "オーバーシュート = {overshootPercent}%",
      "rise-time": "立上り時間（10％～90％）= {riseTime}s",
      "title": "パルス応答",
      "tooltip": "Pulse Response",
      "x-title": "時間（秒）",
      "y-title": "回路出力（V）"
    },
    "schematic": {
      "amp-single-stage-title-1": "トランスインピーダンス・",
      "amp-single-stage-title-2": "アンプ",
      "amp-single-stage-title-3": "",
      "amp-stage-one-title-1": "1段",
      "amp-stage-one-title-2": "トランスインピーダンス・",
      "amp-stage-one-title-3": "アンプ",
      "amp-stage-two-title-1": "2段",
      "amp-stage-two-title-2": "追加ゲイン",
      "amp-stage-two-title-3": "とフィルタリング",
      "bypass-capacitors": "バイパスコンデンサ",
      "equivalent-circuit-tooltip": "Equivalent Circuit",
      "photodiode-model": "フォトダイオードの等価回路モデル ( {pd} )",
      "photodiode-model-custom": "カスタム",
      "photodiode-model-next-steps": "製品番号: {pd}",
      "photodiode-stage-title-1": "フォトダイオード",
      "photodiode-stage-title-2": "",
      "spares": "スペア",
      "supply-voltage-title-1": "供給電圧",
      "supply-voltage-title-2": "最小値: ± {minVoltage}V",
      "supply-voltage-title-3": "最大値: ± {maxVoltage}V",
      "supply-voltage-tooltip": "Supply Voltage",
      "title": "回路",
      "warning-cf-less-than-1pF": "警告：お客様の設計回路に必要とされるフィードバック容量（Cf）は {feedback}F。 この低いレベルおいては、基板の寄生容量はこの設計のピーキング(Q)に大きく影響します。 Cfの実際の値はお客様のPCBボードで実験的に決める必要があります。 値が低すぎるのでツールはコンデンサ容量を標準値に変換しませんでした。",
      "warning-gain-greater-than-1-stable": "Warning:  This circuit may not be stable. The {opamp} is stable for noise gains of {gain} or greater. This means (Cd + Cf) / Cf should be larger than {gain}. In the circuit above Cd = {capacitance}F and Cf = {feedback}F, so (Cd + Cf) / Cf = {noise}. Make sure you verify in spice before building.",
      "why-the-spares-tooltip": "Why the Spares?"
    },
    "snr": {
      "enob": "ENOB = {enob} bits",
      "minimum-signal": "最小信号（ノイズフロア）",
      "noise-1f-not-modeled": "1/fノイズとテール電流ノイズはモデル化されていません。",
      "noise-contributors": "ノイズの要因 (V rms)",
      "noise-floor": "出力換算: {voltage}V rms",
      "noise-referred-output": "全出力換算ノイズ",
      "opamp-current": "オペアンプ電流",
      "opamp-voltage": "オペアンプ電圧",
      "output-voltage": "出力電圧: {voltage}V",
      "peak-signal": "ピークシグナル",
      "photodiode-current": "フォトダイオード電流: {current}A",
      "photodiode-current-rms": "入力換算: {current}A rms",
      "rf": "R<sub>F</sub>",
      "rfilter": "R<sub>FILTER</sub>",
      "rg": "R<sub>G</sub>",
      "rin": "R<sub>IN</sub>",
      "snr": "SNR = {snr} dB",
      "stage-1": "1段目",
      "stage-1-total": "1段目合計",
      "stage-2": "2段目",
      "stage-2-total": "2段目合計",
      "title": "SNR",
      "tooltip": "SNR/Dynamic Range",
      "total": "合計",
      "total-noise": "総合ノイズ: {noise}V rms"
    },
    "spectral-noise": {
      "graph-legend": {
        "opi": "Op Amp I",
        "opi2": "Op Amp 2 I",
        "opv": "Op Amp V",
        "opv2": "Op Amp 2 V",
        "rf": "R<sub>f</sub>",
        "rfilter": "R<sub>filter</sub>",
        "rin": "R<sub>in</sub>",
        "total": "Total",
        "x-title": "周波数"
      },
      "hover-graph-legend": {
        "opi": "Op Amp I: ",
        "opi2": "Op Amp 2 I: ",
        "opv": "Op Amp V: ",
        "opv2": "Op Amp 2 V: ",
        "rf": "Rf: ",
        "rfilter": "Rfilter: ",
        "rin": "Rin: ",
        "total": "Total: ",
        "x-title": "周波数: ",
        "x-unit": "Hz",
        "y-unit": "V/√Hz"
      },
      "title": "スペクトラル・ノイズ密度",
      "tooltip": "Spectral Noise Density",
      "x-title": "周波数（Hz)",
      "y-title": "スペクトラル・ノイズ密度 (V/√Hz)"
    }
  },
  "help": {
    "bias-polarity": {
      "title": "フォトダイオード・バイアス"
    },
    "circuit-peaking": {
      "title": "出力信号：ピーキング"
    },
    "circuit-stages": {
      "title": "段"
    },
    "dynamic-range": {
      "title": "SNR/ダイナミック・レンジ"
    },
    "equivalent-circuit": {
      "title": "フォトダイオードの等価回路"
    },
    "frequency-response": {
      "title": "周波数応答"
    },
    "main-help": {
      "title": "フォトダイオード回路設計ウィザードのヘルプ"
    },
    "noise-gain": {
      "title": "ノイズ・ゲイン"
    },
    "opamp": {
      "title": "オペアンプ"
    },
    "peak-current": {
      "title": "フォトダイオードの仕様：ピーク電流"
    },
    "peak-voltage": {
      "title": "出力信号：ピーク電圧"
    },
    "photodiode-capacitance": {
      "title": "フォトダイオードの仕様：容量(C<sub>D</sub>）"
    },
    "pulse-response": {
      "title": "パルス応答"
    },
    "quick-results": {
      "title": "クイック・リザルト"
    },
    "reverse-voltage": {
      "title": "フォトダイオード・バイアス:  逆電圧 (V<sub>R</sub>)"
    },
    "shunt-resistance": {
      "title": "フォトダイオードの仕様：シャント抵抗(R<sub>SH</sub>)"
    },
    "spectral-noise-density": {
      "title": "スペクトル・ノイズ密度"
    },
    "stability": {
      "title": "安定性"
    },
    "supply-voltage": {
      "title": "供給電圧"
    },
    "target-speed": {
      "title": "出力信号：スピード"
    },
    "why-the-spares": {
      "title": "なぜ予備品？"
    }
  },
  "main": {
    "busy": "処理中・・・",
    "next-tab": "次のタブ",
    "previous-tab": "前のタブ",
    "title": "フォトダイオード 回路設計 ウィザード"
  },
  "marginal-design": {
    "button": "設計限界を示します",
    "message": "ロバストな設計回路を作成するために、上記のような設計回路のパラメータを調整する事をお勧めします。 もしそれができなければ、動作すると思われるオペアンプを探す事は困難です。 ツールはこの設計回路で次の問題を認識しました。 "
  },
  "menu": {
    "links": {
      "feedback": "ご意見 ・ ご要望",
      "help": "ヘルプ",
      "load": "設計を読み込む",
      "save": "保存"
    },
    "tabs": {
      "circuit-design": "回路設計",
      "next-steps": "次のステップ",
      "photodiode": "フォトダイオード"
    }
  },
  "model-error": {
    "amp_status_bias_current_is": "高い出力オフセット（バイアス電流は {data})",
    "amp_status_big_2nd_stage_gain": "要求される2段目のゲインは {data}",
    "amp_status_cf_less_100fF": "Cf < 0.1pF",
    "amp_status_cf_less_50fF": "Cf < 50fF",
    "amp_status_cfb_no_cf": "現在の帰還アンプでは帰還パスのコンデンサに対応できません。",
    "amp_status_cfb_rf_too_small": "无法驱动Rf； ",
    "amp_status_dB_error": "データベース・エラー - データベースの一部間違ったデータ",
    "amp_status_gbw_less_than_bandwith_requested": "Op Amp GBW less than bandwidth requested ",
    "amp_status_high_vos": "高い出力オフセット（入力 Vosは {data})",
    "amp_status_internal_cf_too_high": "内部フィードバック容量が高すぎる",
    "amp_status_min_stable_gain": "最小安定ゲイン＝ {data}",
    "amp_status_not_enough_peaking": "充分なピークを作成できません",
    "amp_status_not_fast_enough": "速度が十分でありません",
    "amp_status_quad": "クワッド",
    "amp_status_slew_rate_low": "スルーレートの値が低すぎます",
    "amp_status_slew_rate_marginal": "スルーレートが不十分",
    "amp_status_specialty_amp": "特殊機能アンプ",
    "amp_status_too_fast": "高速アンプ＝低SNR",
    "amp_status_voltage_not_enough": "電圧範囲はピーク出力電圧に対して不十分です",
    "amp_status_zero_drift": "ゼロ・ドリフト",
    "fixed_op_amp_no_good": "{partName}で設計要求を満たすことはできません。別のオペアンプを選択するか、オペアンプのロックを解除してプログラムを使って選択してください。<br/><br/>{partName}は理由として適していません。:",
    "internal_cf_too_high": "{partName}の内部フィードバック容量は{cfint}Fです。そのため、標準的なアンプでは通常{cf}Fの帰還容量が、{partName}では{cfext}Fとなります。  <br/><br/>{partName}が不向きな理由：",
    "no_op_amps_available_for_first_stage_too_fast": "<p>設計要求を満たす1段目のオペアンプはありません。</p><p>以下をお試しください： <ul><li>速度に対する要求を低くしてください</li><li>フォトダイオードの容量を小さくしてください</li><li>ピーク出力電圧を低くしてください</li><li>フォトダイオードのピーク電流を増やす</li></ul></p>",
    "no_op_amps_available_for_first_stage_too_slow": "<p>これらの設計要求を満たすオペアンプはありません。</p><p>以下をお試しください： <ul><li>2段回路構成を選んでください</li><li>速度に対する要求を低くしてください</li><li>フォトダイオードの容量を小さくしてください</li><li>ピーク出力電圧を低くしてください</li><li>フォトダイオードのピーク電流を増やしてください</li></ul></p>",
    "no_op_amps_available_for_second_stage": "<p>設計要求を満たす2段目のオペアンプはありません。</p><p>解決方法： <ul><li>速度に対する要求を低くしてください</li><li>ピーク出力電圧を低くしてください</li></ul></p>",
    "no_op_amps_available_for_single_stage_too_fast": "<p>これらの設計要求を満たすオペアンプはありません。</p><p>以下をお試しください： <ul><li>2段回路構成を選んでください</li><li>速度に対する要求を低くしてください</li><li>フォトダイオードの容量を小さくしてください</li><li>ピーク出力電圧を低くしてください</li><li>フォトダイオードのピーク電流を増やしてください</li></ul></p>",
    "no_op_amps_available_for_single_stage_too_slow": "<p>これらの設計要求を満たすオペアンプはありません。</p><p>以下をお試しください： <ul><li>速度を増やす</li><li>フォトダイオードの容量を大きくする</li><li>ピーク出力電圧を大きくする</li><li>フォトダイオードのピーク電流を減少させる</li></ul></p>",
    "peak_light_error": "お客様が入力したピーク電流は許容範囲内に入りません ({min} - {max})。 値を更新してください。",
    "peak_photodiode_error": "ピーク電流は許容範囲内に入りません ({min} - {max})。",
    "rf_too_high": "<p>必要となるゲインは１段のアンプ構成としては高過ぎます。</p><p>解決方法： <ul><li>2段回路構成を選んでください</li><li>ピーク出力電圧を低くしてください</li><li>フォトダイオードのピーク電流を増やしてください</li></ul></p>"
  },
  "opamp-selection": {
    "GBW": "GBW",
    "cancel": "キャンセル",
    "comment-drop-down": {
      "message": {
        "amp_status_bias_current_is": "高い出力オフセット（バイアス電流は {value}A)",
        "amp_status_big_2nd_stage_gain": "要求される2段目のゲインは {value}",
        "amp_status_cf_less_100fF": "Cf < 0.1pF",
        "amp_status_cf_less_50fF": "Cf < 50fF",
        "amp_status_cfb_no_cf": "現在の帰還アンプでは帰還パスのコンデンサに対応できません。",
        "amp_status_cfb_rf_too_small": "无法驱动Rf； ",
        "amp_status_dB_error": "データベース・エラー - データベースの一部間違ったデータ",
        "amp_status_gbw_less_than_bandwith_requested": "Op Amp GBW less than bandwidth requested ",
        "amp_status_high_vos": "高い出力オフセット（入力 Vosは {value}V)",
        "amp_status_internal_cf_too_high": "内部フィードバック容量が高すぎる",
        "amp_status_last_time_buy": "ラスト・タイム・バイ",
        "amp_status_min_stable_gain": "最小安定ゲイン＝ {value}  ",
        "amp_status_not_allowed": "使用できません:",
        "amp_status_not_enough_peaking": "充分なピークを作成できません",
        "amp_status_not_fast_enough": "速度が十分でありません",
        "amp_status_not_recommended": "非推奨:",
        "amp_status_not_recommended_for_new_designs": "新規設計にお勧めしません。",
        "amp_status_obsolete": "生産中止",
        "amp_status_quad": "クワッド",
        "amp_status_recommended": "推奨",
        "amp_status_slew_rate_low": "スルーレートの値が低すぎます",
        "amp_status_slew_rate_marginal": "スルーレートが不十分",
        "amp_status_specialty_amp": "特殊機能アンプ",
        "amp_status_too_fast": "高速アンプ＝低SNR",
        "amp_status_voltage_not_enough": "電圧範囲はピーク出力電圧に対して不十分です",
        "amp_status_zero_drift": "ゼロ・ドリフト"
      },
      "not-allowed": "許可されていない",
      "not-allowed-match": "使用できません",
      "not-recommended": "おススメではない",
      "not-recommended-match": "非推奨",
      "recommended": "お勧め",
      "recommended-match": "推奨",
      "show-all": "すべて表示"
    },
    "comments": "コメント",
    "part-label": "部品",
    "row-count": "'{count, plural, =0 {{total}製品中#個のオペアンプを表示しています。フィルタを確認してください。} other {{total}製品中#個のオペアンプを表示しています。}}'",
    "select": "選ぶ",
    "spice-drop-down": {
      "no": "いいえ",
      "show-all": "すべて表示",
      "yes": "はい"
    },
    "status-drop-down": {
      "not-recommended": "新規設計には非推奨",
      "not-recommended-match": "Not Recommended for New Designs",
      "production": "生産／供給中",
      "production-match": "Production",
      "recommended": "新規設計にお薦めします。",
      "recommended-match": "Recommended for New Designs",
      "show-all": "すべて表示"
    },
    "supply-max": "最大供給",
    "supply-min": "最少供給",
    "temp-range": "温度範囲",
    "title": "オペアンプを選ぶ"
  },
  "parameter-selector": {
    "choose-parameters": "パラメータを選ぶ",
    "ok": "OK"
  },
  "sensor-selection": {
    "active-area": "アクティブ領域",
    "cancel": "キャンセル",
    "capacitance": "静電容量",
    "dark-current": "暗電流",
    "manufacturer": "メーカー名",
    "operating-temperature": "動作温度",
    "package": "梱包",
    "part-number": "部品番号",
    "product-page": "製品ページ",
    "resistance": "抵抗",
    "response-time": "応答時間",
    "reverse-breakdown": "逆方向ブレークダウン",
    "row-count": "'{count, plural, =0 {{total}製品中#個のセンサーを表示しています。フィルタを確認してください。} other {{total}製品中#個のセンサーを表示しています。}}'",
    "select": "選ぶ",
    "sensitivity": "感度",
    "spectral-peak": "スペクトルのピーク",
    "spectral-range": "スペクトル範囲",
    "spice": "SPICE",
    "spice-file": "SPICEファイル",
    "title": "センサーをお選びください。",
    "vendor-link": "ベンダーのデータシートリンク",
    "viewing-angle": "視野角"
  },
  "settings": {
    "circuit-design": {
      "enob": "ENOB: {enob} bits",
      "one-stage": "1 段",
      "opamp-lock": "Lock",
      "opamp-stage1": "1段",
      "opamp-stage2": "2段",
      "opamps": "Op Amps:",
      "opamps-tooltip": "Op Amp",
      "output-offset": "出力オフセット: {offset}V",
      "output-signal": "出力信号",
      "peak-voltage": "ピーク電圧 (V<sub>P</sub>)",
      "peak-voltage-tooltip": "ピーク電圧",
      "peaking": "ピーク",
      "peaking-high": "高",
      "peaking-low": "低",
      "peaking-tooltip": "ピーク",
      "quick-results": "クイック・リザルト",
      "quick-results-tooltip": "クイック・リザルト",
      "snr": "SNR: {snr} dB",
      "stages": "段",
      "stages-tooltip": "段",
      "target-bandwidth": "Target Bandwidth",
      "target-option-band": "帯域幅",
      "target-option-pulse": "パルス幅",
      "target-pulse-width": "目標とする速度",
      "target-speed-tooltip": "Speed",
      "two-stage": "2 段"
    },
    "next-steps": {
      "get-files": "ファイル取得",
      "get-files-all": "設計用ファイル",
      "get-files-all-tooltip": "SPICEファイル、BOM、評価ボードデザインファイル、PDFファイルのバージョン情報等が格納されたzipファイルをダウンロードする ",
      "get-files-spice": "SPICE ファイル",
      "get-files-spice-tooltip": "SPICEファイルを含んだzipファイルをダウンロード",
      "mail": "同僚にメールする(email)",
      "mail-tooltip": "同僚に送る",
      "order": "注文",
      "order-samples": "サンプル注文",
      "order-samples-tooltip": "構成部品のサンプルを注文",
      "share": "共有"
    },
    "photodiode": {
      "bias-polarity-tooltip": "フォトダイオードのバイアス電圧",
      "capacitance-1": "静電容量 (C<sub>D</sub>)",
      "capacitance-2": "@ V<sub>R</sub> = {vr} V",
      "capacitance-tooltip": "静電容量",
      "capacitance-warning": "Be careful. This is the capacitance at <u>your</u> reverse voltage, which may be different than what is specified in the datasheet table. You may need to read this value from a datasheet graph instead.",
      "or": "または",
      "peak-current": "ピーク電流 (I<sub>P</sub>)",
      "peak-current-tooltip": "ピーク電流",
      "photodiode-bias": "フォトダイオードのバイアス電圧",
      "photodiode-select": "フォトダイオードを選択",
      "photodiode-specs": "フォトダイオードの仕様",
      "reverse-voltage": "逆電圧 (V<sub>R</sub>)",
      "reverse-voltage-negative": "負",
      "reverse-voltage-positive": "正",
      "reverse-voltage-tooltip": "逆電圧",
      "shunt-resistance": "フォトダイオードのシャント抵抗 (R<sub>SH</sub>)",
      "shunt-resistance-tooltip": "フォトダイオードのシャント抵抗"
    }
  },
  "units": {
    "A": "A",
    "F": "F",
    "Q": "Q",
    "R": "Ω",
    "V": "V",
    "active-area": "mm<sup>2</sup>",
    "dB": "dB",
    "farad": "F",
    "hertz": "Hz",
    "meters": "m",
    "ohm": "Ohm",
    "operating-temperature": "&deg;C",
    "peak-light-intensity": " W/m<sup>2</sup>",
    "seconds": "s",
    "sensitivity": "A/W",
    "unit-price": "$ US",
    "viewing-angle": "&deg;",
    "volts-per-amp": "V/A",
    "volts-per-volt": "V/V"
  },
  "validation-error": {
    "button-tooltip": "エラーを修正してから続けてください。",
    "capacitance": "コンデンサ値は次の範囲にある必要があります： {min} ～ {max}",
    "invalid-input-error": "{field}フィールドに入力された{value}という値は解析できません。",
    "min-pulse-speed": "速度の値は次の範囲にある必要があります： {min} ～ {max}",
    "no-opamp-found": "None found",
    "peak-current": "ピーク電流値は次の範囲にある必要があります： {min} ～ {max}",
    "peak-light-intensity": "光量のピーク強度の範囲: {min} ～ {max}",
    "peak-voltage": "ピーク電圧値は次の範囲にある必要があります： {min} ～ {max}",
    "reverse-voltage": "逆電圧値は次の範囲にある必要があります： {min} ～ {max}",
    "shunt-resistance": "シャント抵抗値は次の範囲にある必要があります： {min} ～ {max}",
    "speed": "速度の値は次の範囲にある必要があります： {min} ～ {max}"
  }
}], ["zh-cn", {
  "controls": {
    "future": {
      "placeholder": "未来发展的占位符",
      "q": "Q"
    },
    "schematic-table": {
      "model": {
        "photodiode": {
          "bias": "偏见",
          "cd": "光盘",
          "circuitName": "电路名称",
          "ip": "ip",
          "rsh": "rsh",
          "vBias": "偏差",
          "vr": "虚拟现实"
        },
        "stage1": {
          "bw": "体重",
          "cf": "参考",
          "cin": "辛",
          "opamp": {
            "partNumber": "运算放大器"
          },
          "q": "q",
          "rf": "射频",
          "rin": "凛",
          "title": "阶段1"
        },
        "stage2": {
          "bw": "bw",
          "cfilter": "cfilter",
          "opamp": {
            "partNumber": "opAmp"
          },
          "rf": "rf",
          "rfilter": "rfilter",
          "rg": "rg",
          "title": "Stage 2"
        }
      },
      "title": "光电二极管"
    }
  },
  "current-calculation": {
    "active-area": "有效面积:",
    "cancel": "取消",
    "equals": " = ",
    "instruction": "输入光强度峰值或光电二极管峰值电流：",
    "multiply": " X ",
    "peak-current": "光电二极管峰值电流:",
    "peak-light-intensity": "光强度峰值:",
    "sensitivity": "灵敏度:",
    "title": "光电二极管峰值电流计算",
    "use-this-peak": "采用该峰值电流"
  },
  "dialogs": {
    "download": {
      "error-message": "<p>无法获取设计文件。出现此错误的原因可能有：</p><p>1)与服务器的连接中断。</p><p>2)服务中断。</p>",
      "error-title": "下载"
    },
    "feedback": {
      "email": "电子邮件：",
      "feedback": "你的反馈：",
      "feedback-dialog-ng-message": "您的反馈发送失败。可能是由于服务器的连接问题，请尝试再次发送。",
      "feedback-dialog-ok-message": "您的反馈已经发送。",
      "give-feedback": "给予反馈",
      "invitation": "请告诉我们你对这款工具的看法，任何好的或坏的。 ",
      "name": "姓名：",
      "optional": "(Optional)",
      "title": "提交您的意见或反馈！"
    },
    "load": {
      "invalid-file": "设计文件无效。请验证您尝试加载的设计文件的内容。",
      "invalid-parts": "{numParts,plural,other{如果不能加载设计，接下来的设计文件将不支持这个应用：}}{parts}",
      "no-opamps": "运算放大器数据不可用。无法加载设计。请尝试刷新浏览器。如果问题依然存在，请使用光电二极管设计向导右上方的反馈按钮来报告该问题。",
      "title": "加载设计"
    },
    "samples": {
      "title": "申请样片"
    },
    "save": {
      "error-message": "無法保存設計。保存前請檢查您輸入的數據是否正確。",
      "error-title": "保存設計"
    },
    "share": {
      "share-dialog-ng-message": "无法共享设计，这可能是因为服务器连接问题。请重试。",
      "share-dialog-ok-message": "已共享设计",
      "title": "通过邮件发送我的设计"
    },
    "system": {
      "application-busy": "处理中...",
      "connecting-to": "Connecting to {tool}...",
      "download-create-bom": "正在创建BOM文件...",
      "download-create-data": "正在创建数据文件...",
      "download-create-design": "正在创建设计文件...",
      "download-create-eval-board": "正在创建评估板文件...",
      "download-create-graph": "正在创建图形数据...",
      "download-create-pdf": "正在创建PDF文件...",
      "download-create-spice": "正在创建SPICE文件...",
      "download-downloading": "正在下载……",
      "download-requesting": "正在请求……",
      "error-config-data": "配置数据不可用。由于因此无法正确验证光电二极管规格，无法继续进行操作。请尝试刷新浏览器。如果问题依然存在，请使用光电二极管设计向导右上方的反馈按钮来报告该问题。",
      "error-opamp-data": "运算放大器数据不可用。光电二极管设计向导无法继续运行。请保存您的设计，然后尝试刷新浏览器。如果问题依然存在，请使用光电二极管设计向导右上方的反馈按钮来报告该问题。",
      "error-pst-data": "数据映射暂时不可用，因此无法显示运算放大器表。请保存您的设计，然后尝试刷新浏览器。如果问题依然存在，请使用光电二极管设计向导右上方的反馈按钮来报告该问题。",
      "error-sensor-data": "传感器数据暂时不可用，因此无法显示传感器表。请保存您的设计，然后尝试刷新浏览器。如果问题依然存在，请使用光电二极管设计向导右上方的反馈按钮来报告该问题。",
      "loading-opamp-data": "加载 OpAmp 数据...",
      "sending-filter": "Sending filter to {tool}...",
      "title": "应用消息"
    }
  },
  "download": {
    "data-files": {
      "frequency-response": {
        "frequency": "频率",
        "magnitude": "幅度"
      },
      "noise-gain": {
        "caps": "(Cin + Cf) / Cf",
        "frequency": "频率",
        "noise-gain": "噪声增益",
        "opamp-gain": "运算放大器增益",
        "zero": "(Cin || Cf) (Rin || Rf) </br> Zero"
      },
      "pulse-response": {
        "pulse-response": "脉冲响应",
        "time-axis": "时间轴"
      },
      "spectral-noise": {
        "frequency": "频率",
        "opi": "Op Amp I",
        "opi2": "Op Amp 2 I",
        "opv": "Op Amp V",
        "opv2": "Op Amp 2 V",
        "rf": "Rf",
        "rfilter": "Rfilter",
        "rin": "Rin",
        "total": "Total"
      }
    },
    "pdf-content": {
      "pdf-data-fields": {
        "capacitance": "电容 (Cd)",
        "one-stage": "单级",
        "peak-current": "峰值电流 (Ip)",
        "peak-voltage": "峰值电压 (Vp)",
        "photodiode-bias": "光电二极管偏置",
        "requested-bandwidth": "要求带宽",
        "reverse-voltage": "反向电压 (Vr)",
        "sensor": "传感器",
        "shunt-resistance": "分流电阻 (Rsh)",
        "stages": "级数",
        "two-stage": "双级"
      },
      "pdf-data-ie-image-missing": "很遗憾，若您使用IE 8或更低版本的IE浏览该工具，将无法生成图片。若您想要浏览页面上的图片，请使用Firefox、Chrome、IE 9或更高版本的IE浏览器。",
      "pdf-desc": "{desc}\n\n由{user}在{date}上创建",
      "pdf-desc-no-design-name": "由 {user}　创建于{date}",
      "pdf-desc-no-name-desc": "创建于{date}",
      "pdf-desc-no-user-name": "{desc}\n\n创建于 {date}",
      "pdf-heading": "光电二极管设计报告",
      "pdf-page-headers": {
        "bill-of-materials": "物料清单",
        "circuit": "电路",
        "frequency-response": "频率响应",
        "noise-gain": "噪声增益",
        "pulse-response": "脉冲响应",
        "snr": "SNR",
        "spectral-noise": "频谱噪声密度"
      },
      "pdf-subheading": "Photodiode属性和器件",
      "pdf-tool-name": "光电二极管"
    },
    "spice-files": {
      "message_netlist_readme": "This directory (Spice Files) contains three simulation-ready SPICE netlists.\r\nThese netlists contain the photodiode amplifier design generated by Photodiode \r\nWizard, and the corresponding SPICE macromodels for the selected op amp(s). \r\nAlso included is a suitable input signal, and appropriate analysis mode \r\n(.AC, .TRAN, .NOISE).\r\n\nThese netlists are text-based .cir files, and should be compatible with a wide\r\nvariety of SPICE simulators.  More information about text-based SPICE netlists\r\ncan be found at: http://bwrcs.eecs.berkeley.edu/Classes/IcBook/SPICE/ \r\n\n\t- ACAnalysis.cir: Simulates AC response of the photodiode amplifier design. \r\n\t                  Output of circuit can be plotted by probing V(OUT) \r\n\n\t- TransientAnalysis.cir: Simulates the step response of the photodiode \r\n\t                         amplifier design. Output of circuit can be plotted by \r\n\t                         probing V(OUT) \r\n\n\t- NoiseAnalysis.cir: Simulates the noise of the photodiode amplifier design. \r\n\t                     Noise gain can be plotted by probing GAIN, or \r\n\t                     V(ONOISE)/V(INOISE) \r\n\n\nAny questions about these SPICE netlists, or about Photodiode Wizard in general \r\ncan be submitted at: \r\nhttp://ez.analog.com/community/amplifiers/operational-amplifiers \r\n",
      "message_netlist_readme_filename": "README.txt",
      "message_no_netlist_filename": "Why no netlist files.txt",
      "message_no_schematic": "既然 LTspice 是ADI公司的一部分，我们可将SPICE网络列表转换为 LTspice 模型。设计中的运算放大器当前没有可用的 LTspice 模型。如果您希望ADI优先考虑针对特定器件生成 LTspice 模型，请告诉您的销售代表或通过此工具发送反馈。\r\n\r\n由您设计中的器件支持的SPICE仿真：\r\n",
      "message_no_schematic_filename": "Why no LTspice.txt",
      "message_no_schematic_no_netlist": "ADI当前正处于将运算放大器从SPICE网络列表转换为LTspice模型的过程。您的设计包含一系列器件，有些器件具有基于文本的网络列表，而另一些具有LTspice文件。为此，该工具无法生成任何SPICE输出。对于由此带来的不便，我们表示歉意并将努力解决此问题。如果您希望ADI优先考虑针对特定器件生成LTspice模型，请告诉您的销售代表或通过此工具发送反馈。\r\n\r\n由您设计中的器件支持的SPICE仿真：\r\n",
      "message_no_schematic_no_netlist_filename": "README.txt",
      "message_part_no_netlist": "以下部分无法生成网表模型信息。\r\n",
      "message_part_no_spice_info": "The following op amps in your design do not have LTspice models or text netlist models.\r\nIf you would like ADI to prioritize LTspice model generation for a particular part, please let your sales representative know or send feedback through this tool.\r\n",
      "message_part_no_spice_info_filename": "Why no spice files.txt"
    }
  },
  "ember-aditools-page": {
    "card": {
      "checkbox-tooltip": "Toggle",
      "help-tooltip": "Click for help",
      "part-number-tooltip": "Click to select part"
    },
    "common": {
      "cancel": "取消",
      "close": "关闭",
      "load": "加载",
      "ok": "确定",
      "open": "打开",
      "save": "保存",
      "select": "选择"
    },
    "dialogs": {
      "feedback": {
        "email": "电子邮件：",
        "feedback": "你的反馈：",
        "give-feedback": "给予反馈",
        "invitation": "请告诉我们你对这款工具的看法，任何好的或坏的。 ",
        "name": "姓名：",
        "optional": "(Optional)",
        "title": "提交您的意见或反馈！"
      },
      "load": {
        "choose-button": "选择文档",
        "message": "从计算机文件中加载设计",
        "no-file-selected": "No file selected.",
        "title": "加载设计"
      },
      "samples": {
        "add-button": "添加所选样片至购物车",
        "add-link": "Add to Order",
        "add-to-cart-column": "样片加入购物车",
        "model-column": "元器件模型/封装",
        "part-column": "组成部分",
        "quantities-warning": "ADI公司向符合条件的客户免费限量提供样片。 出于客户对我们产品样片有大量需求，两周内，每款器件您只能申请2片，每份申请最多申请4款器件。 如果您的设计需要额外数量的产品，请在网站上通过在线购买或者联系我们的授权代理商购买。",
        "title": "申请样片",
        "unavailable-message": "无法申请样片"
      },
      "save": {
        "save-desc-error": "请提供描述",
        "save-desc-field": "介绍",
        "save-name-error": "请输入设计名称",
        "save-name-field": "设计名称",
        "title": "保存"
      },
      "share": {
        "share-button": "Email",
        "share-design-information": "<p>若要共享您的设计副本，请在 <b>发件人名称</b> 字段中输入您的姓名。然后在 <b>共享设计</b> 字段中输入收件人的电子邮件地址。多个收件人的地址需分行填写。</p><p>收件人将收到ADI发出的电子邮件，内含包括共享设计ZIP存档的附件。您只需要从ZIP文件中提取设计并使用应用的“加载设计”功能上传。</p><p>本过程为每个收件人创建一份设计副本。收件人编辑他们的副本并不会影响您保存在您自己的电脑中的设计。</p>",
        "share-dialog-ng-message": "无法共享设计，这可能是因为服务器连接问题。请重试。",
        "share-dialog-ok-message": "已共享设计",
        "share-duplicate-email": "找到重复的电子邮件",
        "share-email-empty-error": "请输入电子邮件地址",
        "share-email-field": "收件人",
        "share-email-format-error": "您输入的电子邮件地址中有一个或多个无效，请更正后重试。",
        "share-email-placeholder": "电子邮件地址",
        "share-name-error": "请输入设计名称",
        "share-name-field": "设计名称",
        "share-sender-error": "请提交收件人姓名",
        "share-sender-field": "收件人姓名",
        "title": "通过邮件发送我的设计"
      },
      "system": {
        "application-busy": "处理中...",
        "title": "应用消息"
      }
    },
    "footer": {
      "accessibility": "可访问性",
      "cookie-settings": "Cookie设置",
      "copyright-text": "1995 - 2025 Analog Devices, Inc. 保留所有权利",
      "icp-id": "<a href=\"https://beian.miit.gov.cn/\">沪ICP备09046653号-1</a>",
      "legal": "法律与风险",
      "privacy-policy": "隐私政策",
      "privacy-settings": "隐私设置",
      "sitemap": "网站地图"
    },
    "header": {
      "applications": "应用",
      "company": "公司",
      "design-center": "设计中心",
      "education": "教育培训",
      "parametric-search": "参数搜索",
      "products": "产品",
      "spoken": {
        "homepage": "ADI主页",
        "sitelinks": "ADI网站链接"
      },
      "support": "支持"
    },
    "menubar": {
      "chinese": "简体中文",
      "english": "English",
      "help": "帮助",
      "japanese": "日本語",
      "load": "加载设计",
      "save": "保存"
    },
    "studio": {
      "adcdriver": "ADC驱动器",
      "dacebc": "DAC",
      "diamond": "仪表放大器",
      "filterwizard": "模拟滤波器",
      "noise": "噪声",
      "photodiode": "光电二极管",
      "precisionstudio": "ADI<span class=''service-mark''>℠</span> Precision Studio",
      "signalchaindesigner": "Signal Chain",
      "simdds": "DDS",
      "spoken": {
        "studiolinks": "ADI Precision Studio链接"
      },
      "virteval": "Virtual Eval"
    },
    "toolbar": {
      "actions": "Actions"
    }
  },
  "figures": {
    "bom": {
      "description": " 点击“获取设计文件”下载Zip包，其中包含一张表格形式的物料清单。",
      "designator": "标识",
      "extra-components": {
        "header": "表头",
        "jumper": "跳线",
        "sma-jack": "SMA插孔、插口式电路板边缘",
        "sma-male": "插入式-插入式SMA",
        "socket": "插座",
        "test-pin": "测试引脚"
      },
      "material": "材料",
      "materials": {
        "tantalum": "钽"
      },
      "package": "封装",
      "quantity": "数量",
      "title": "材料清单（BOM）",
      "tolerance": "容差",
      "value": "值"
    },
    "frequency-response": {
      "fn": "f<tspan dy=\"5px\">N</tspan><tspan dy=\"-5px\"> = {fn}Hz</tspan>",
      "hover-graph-legend": {
        "trans-gain": "跨阻增益: ",
        "x-title": "频率: ",
        "x-unit": "Hz",
        "y-unit": "dB",
        "y-unit2": "V/A"
      },
      "q": "Q = {q}",
      "title": "频率响应",
      "tooltip": "Frequency Response",
      "x-title": "频率（Hz）",
      "y-title": "跨阻增益（{unit}）"
    },
    "noise-gain": {
      "graph-legend": {
        "caps": "(C<sub>in</sub> + C<sub>f</sub>) / C<sub>f</sub>",
        "noise-gain": "噪声增益",
        "opamp-gain": "运算放大器增益",
        "x-title": "频率",
        "zero": "(C<sub>in</sub> || C<sub>f</sub>) (R<sub>in</sub> || R<sub>f</sub>) <br/> Zero"
      },
      "hover-graph-legend": {
        "caps": "(Cin + Cf) / Cf: ",
        "noise-gain": "噪声增益: ",
        "opamp-gain": "运算放大器增益: ",
        "x-title": "频率: ",
        "x-unit": "Hz",
        "y-unit": "dB",
        "y-unit2": "V/V",
        "zero": "(Cin || Cf) (Rin || Rf) Zero: "
      },
      "title": "噪声增益",
      "tooltip": "噪声增益",
      "x-title": "频率（Hz）",
      "y-title": "增益（{unit}）"
    },
    "pulse-response": {
      "hover-graph-legend": {
        "circuit-output": "电路输出: ",
        "x-title": "时间: ",
        "x-unit": "s",
        "y-unit": "伏"
      },
      "overshoot": "过冲 = {overshootPercent}%",
      "rise-time": "上升时间（10%至90%）= {riseTime}s",
      "title": "脉冲响应",
      "tooltip": "Pulse Response",
      "x-title": "时间（s）",
      "y-title": "电路输出（伏）"
    },
    "schematic": {
      "amp-single-stage-title-1": "互阻放大器",
      "amp-single-stage-title-2": "",
      "amp-single-stage-title-3": "",
      "amp-stage-one-title-1": "第1级",
      "amp-stage-one-title-2": "互阻放大器",
      "amp-stage-one-title-3": "",
      "amp-stage-two-title-1": "第2级",
      "amp-stage-two-title-2": "额外的增益",
      "amp-stage-two-title-3": "和滤波",
      "bypass-capacitors": "旁路电容",
      "equivalent-circuit-tooltip": "Equivalent Circuit",
      "photodiode-model": "光电二极管模型 ( {pd} )",
      "photodiode-model-custom": "定制",
      "photodiode-model-next-steps": "型号: {pd}",
      "photodiode-stage-title-1": "光电二极管",
      "photodiode-stage-title-2": "",
      "spares": "备件",
      "supply-voltage-title-1": "电源电压",
      "supply-voltage-title-2": "最小值: ± {minVoltage}V",
      "supply-voltage-title-3": "最大值: ± {maxVoltage}V",
      "supply-voltage-tooltip": "Supply Voltage",
      "title": "电路",
      "warning-cf-less-than-1pF": "警告：您的设计所需要的反馈电容Cf仅 {feedback}F. 在如此低的水平下，电路板电容将会显著 产生严重的峰化(Q)影响。实际Cf值应当被确定 根据您特定的PCB板凭经验确定。  由于该数值过低，工具未能转换 电容值转换为标准值。",
      "warning-gain-greater-than-1-stable": "Warning:  This circuit may not be stable. The {opamp} is stable for noise gains of {gain} or greater. This means (Cd + Cf) / Cf should be larger than {gain}. In the circuit above Cd = {capacitance}F and Cf = {feedback}F, so (Cd + Cf) / Cf = {noise}. Make sure you verify in spice before building.",
      "why-the-spares-tooltip": "Why the Spares?"
    },
    "snr": {
      "enob": "ENOB = {enob} bits",
      "minimum-signal": "最小信号(本底噪声)",
      "noise-1f-not-modeled": "1/f和尾电流噪声未建模。",
      "noise-contributors": "噪声来源 (V rms)",
      "noise-floor": "参考输出: {voltage}V rms",
      "noise-referred-output": "所有噪声均指输出",
      "opamp-current": "运算放大器电流",
      "opamp-voltage": "运算放大器电压",
      "output-voltage": "输出电压: {voltage}V",
      "peak-signal": "峰值信号",
      "photodiode-current": "光电二极管电流: {current}A",
      "photodiode-current-rms": "参考输入: {current}A rms",
      "rf": "R<sub>F</sub>",
      "rfilter": "R<sub>FILTER</sub>",
      "rg": "R<sub>G</sub>",
      "rin": "R<sub>IN</sub>",
      "snr": "SNR = {snr} dB",
      "stage-1": "第一级",
      "stage-1-total": "第一级总和",
      "stage-2": "第二级",
      "stage-2-total": "第二级总和",
      "title": "SNR",
      "tooltip": "SNR/Dynamic Range",
      "total": "总",
      "total-noise": "噪声总和: {noise}V rms"
    },
    "spectral-noise": {
      "graph-legend": {
        "opi": "Op Amp I",
        "opi2": "Op Amp 2 I",
        "opv": "Op Amp V",
        "opv2": "Op Amp 2 V",
        "rf": "R<sub>f</sub>",
        "rfilter": "R<sub>filter</sub>",
        "rin": "R<sub>in</sub>",
        "total": "Total",
        "x-title": "频率"
      },
      "hover-graph-legend": {
        "opi": "Op Amp I: ",
        "opi2": "Op Amp 2 I: ",
        "opv": "Op Amp V: ",
        "opv2": "Op Amp 2 V: ",
        "rf": "Rf: ",
        "rfilter": "Rfilter: ",
        "rin": "Rin: ",
        "total": "Total: ",
        "x-title": "频率: ",
        "x-unit": "Hz",
        "y-unit": "V/√Hz"
      },
      "title": "频谱噪声密度",
      "tooltip": "Spectral Noise Density",
      "x-title": "频率（Hz）",
      "y-title": "频谱噪声密度 (V/√Hz)"
    }
  },
  "help": {
    "bias-polarity": {
      "title": "光电二极管偏置"
    },
    "circuit-peaking": {
      "title": "输出信号：峰化"
    },
    "circuit-stages": {
      "title": "级数"
    },
    "dynamic-range": {
      "title": "SNR/动态范围"
    },
    "equivalent-circuit": {
      "title": "光电二极管等效电路"
    },
    "frequency-response": {
      "title": "频率响应"
    },
    "main-help": {
      "title": "光电二极管电路设计向导帮助"
    },
    "noise-gain": {
      "title": "噪声增益"
    },
    "opamp": {
      "title": "运算放大器"
    },
    "peak-current": {
      "title": "光电二极管规格：峰值电流"
    },
    "peak-voltage": {
      "title": "输出信号：峰值电压"
    },
    "photodiode-capacitance": {
      "title": "光电二极管规格：电容(C<sub>D</sub>)"
    },
    "pulse-response": {
      "title": "脉冲响应"
    },
    "quick-results": {
      "title": "快速结果"
    },
    "reverse-voltage": {
      "title": "光电二极管偏置：反向电压 (V<sub>R</sub>)"
    },
    "shunt-resistance": {
      "title": "光电二极管规格：分流电阻(R<sub>SH</sub>)"
    },
    "spectral-noise-density": {
      "title": "频谱噪声密度"
    },
    "stability": {
      "title": "稳定性"
    },
    "supply-voltage": {
      "title": "电源电压"
    },
    "target-speed": {
      "title": "输出信号：速度"
    },
    "why-the-spares": {
      "title": "为何要有备件？"
    }
  },
  "main": {
    "busy": "处理中...",
    "next-tab": "下一个选项卡",
    "previous-tab": "上一个选项卡",
    "title": "光电二极管电路设计向导"
  },
  "marginal-design": {
    "button": "显示边际设计",
    "message": "若要创建鲁棒的设计，我们建议根据下文所述调节您的设计参数。 然而，如果这样做不可行，我们仍能找到可行的运算放大器。 本工具发现该设计存在如下问题： "
  },
  "menu": {
    "links": {
      "feedback": "提交意见反馈",
      "help": "帮助",
      "load": "加载设计",
      "save": "保存"
    },
    "tabs": {
      "circuit-design": "电路设计",
      "next-steps": "后续步骤",
      "photodiode": "光电二极管"
    }
  },
  "model-error": {
    "amp_status_bias_current_is": "高输出失调（偏置电流等于 {data})",
    "amp_status_big_2nd_stage_gain": "需第二级增益 {data}",
    "amp_status_cf_less_100fF": "Cf < 0.1pF",
    "amp_status_cf_less_50fF": "Cf < 50fF",
    "amp_status_cfb_no_cf": "电流反馈放大器的反馈路径不支持电容",
    "amp_status_cfb_rf_too_small": "无法驱动Rf；",
    "amp_status_dB_error": "数据库错误 - 数据库中的器件数据不正确",
    "amp_status_gbw_less_than_bandwith_requested": "Op Amp GBW less than bandwidth requested ",
    "amp_status_high_vos": "高输出失调（输入Vos等于 {data})",
    "amp_status_internal_cf_too_high": "内部反馈电容过高",
    "amp_status_min_stable_gain": "最小稳定增益 = {data}",
    "amp_status_not_enough_peaking": "无法形成足够的峰化",
    "amp_status_not_fast_enough": "不够快",
    "amp_status_quad": "四通道",
    "amp_status_slew_rate_low": "压摆率过低",
    "amp_status_slew_rate_marginal": "边际压摆率",
    "amp_status_specialty_amp": "专用放大器",
    "amp_status_too_fast": "太快",
    "amp_status_voltage_not_enough": "电压范围不足以用于峰值输出电压",
    "amp_status_zero_drift": "零漂移",
    "fixed_op_amp_no_good": "{partName}不能满足设计要求。请选择另外一个运算放大器或解锁，允许程序为您选择运算放大器。 <br/><br/>原因 {partName} 是不适合:",
    "internal_cf_too_high": "{partName} 提供了内部反馈电容 {cfint}F。因此，标准放大器的反馈电容 {cf}F 通常为 {partName} 的 {cfext}F.  <br/><br/>原因 {partName} 不合适：",
    "no_op_amps_available_for_first_stage_too_fast": "<p>无法推荐满足第一级设计要求的运算放大器。</p><p>可以尝试如下方式：<ul><li>降低速度要求</li><li>减小光电二极管电容</li><li>减小峰值输出电压</li><li>增加光电二极管峰值电流</li></ul></p>",
    "no_op_amps_available_for_first_stage_too_slow": "<p>无法推荐满足第一级设计要求的运算放大器。</p><p>可以尝试如下方式：<ul><li>增加速度要求</li><li>增加光电二极管电容</li><li>增加峰值输出电压</li><li>降低光电二极管峰值电流</li></ul></p>",
    "no_op_amps_available_for_second_stage": "<p>无法推荐满足第二级设计要求的运算放大器。</p><p>解决方案： <ul><li>降低速度要求</li><li>减小峰值输出电压</li></ul></p>",
    "no_op_amps_available_for_single_stage_too_fast": "<p>无法推荐满足这些设计要求的运算放大器</p><p>可以尝试如下方式： <ul><li>选择双级解决方案</li><li>降低速度要求</li><li>减小光电二极管电容</li><li>减小峰值输出电压</li><li>增加光电二极管峰值电流</li></ul></p>",
    "no_op_amps_available_for_single_stage_too_slow": "<p>无法推荐满足这些设计要求的运算放大器</p><p>可以尝试如下方式：<ul><li>增加速度要求</li><li>增加光电二极管电容</li><li>增加峰值输出电压</li><li>降低光电二极管峰值电流</li></ul></p>",
    "peak_light_error": "您提供的峰值电流超出可接受范围 ({min} - {max})。 请更新数值。",
    "peak_photodiode_error": "峰值电流计算结果超出可接受范围 ({min} - {max})。",
    "rf_too_high": "<p>单级放大器配置的增益要求过高。.</p><p>可以尝试如下方式： <ul><li>选择双级解决方案</li><li>减小峰值输出电压</li><li>增加光电二极管峰值电流</li></ul></p>"
  },
  "opamp-selection": {
    "GBW": "GBW",
    "cancel": "取消",
    "comment-drop-down": {
      "message": {
        "amp_status_bias_current_is": "高输出失调（偏置电流等于 {value}A)",
        "amp_status_big_2nd_stage_gain": "需第二级增益 {value}",
        "amp_status_cf_less_100fF": "Cf < 0.1pF",
        "amp_status_cf_less_50fF": "Cf < 50fF",
        "amp_status_cfb_no_cf": "电流反馈放大器的反馈路径不支持电容",
        "amp_status_cfb_rf_too_small": "无法驱动Rf；",
        "amp_status_dB_error": "数据库错误 - 数据库中的器件数据不正确",
        "amp_status_gbw_less_than_bandwith_requested": "Op Amp GBW less than bandwidth requested ",
        "amp_status_high_vos": "高输出失调（输入Vos等于 {value}V)",
        "amp_status_internal_cf_too_high": "内部反馈电容过高",
        "amp_status_last_time_buy": "最后一次采购",
        "amp_status_min_stable_gain": "最小稳定增益 = {value}",
        "amp_status_not_allowed": "不允许:",
        "amp_status_not_enough_peaking": "无法形成足够的峰化",
        "amp_status_not_fast_enough": "不够快",
        "amp_status_not_recommended": "不推荐使用:",
        "amp_status_not_recommended_for_new_designs": "新设计不推荐使用本产品",
        "amp_status_obsolete": "停产",
        "amp_status_quad": "四通道",
        "amp_status_recommended": "推荐",
        "amp_status_slew_rate_low": "压摆率过低",
        "amp_status_slew_rate_marginal": "边际压摆率",
        "amp_status_specialty_amp": "专用放大器",
        "amp_status_too_fast": "太快",
        "amp_status_voltage_not_enough": "电压范围不足以用于峰值输出电压",
        "amp_status_zero_drift": "零漂移"
      },
      "not-allowed": "不允许",
      "not-allowed-match": "不允许",
      "not-recommended": "不推荐使用",
      "not-recommended-match": "不推荐使用",
      "recommended": "推荐",
      "recommended-match": "推荐",
      "show-all": "显示全部"
    },
    "comments": "注释",
    "part-label": "产品型号",
    "row-count": "'{count, plural, =0 {显示#/{total}个运算放大器。请检查提供的滤波器。} other {显示#/{total}个运算放大器。}}'",
    "select": "选择",
    "spice-drop-down": {
      "no": "否",
      "show-all": "显示全部",
      "yes": "是"
    },
    "status-drop-down": {
      "not-recommended": "不推荐用于新设计",
      "not-recommended-match": "Not Recommended for New Designs",
      "production": "量产",
      "production-match": "Production",
      "recommended": "推荐用于新设计",
      "recommended-match": "Recommended for New Designs",
      "show-all": "显示全部"
    },
    "supply-max": "最大电源电压",
    "supply-min": "最小电源电压",
    "temp-range": "温度范围",
    "title": "选择运算放大器"
  },
  "parameter-selector": {
    "choose-parameters": "选择参数",
    "ok": "OK"
  },
  "sensor-selection": {
    "active-area": "有效面积",
    "cancel": "取消",
    "capacitance": "电容",
    "dark-current": "暗电流",
    "manufacturer": "制造厂商",
    "operating-temperature": "工作温度",
    "package": "封装",
    "part-number": "产品型号",
    "product-page": "产品页面",
    "resistance": "电阻",
    "response-time": "响应时间",
    "reverse-breakdown": "反向击穿",
    "row-count": "'{count, plural, =0 {Displaying # of {total} sensors. Please check the filters provided.} other {Displaying # of {total} sensors.}}'",
    "select": "选择",
    "sensitivity": "灵敏度",
    "spectral-peak": "频谱峰值",
    "spectral-range": "频谱范围",
    "spice": "SPICE",
    "spice-file": "SPICE文件",
    "title": "请选择一个传感器",
    "vendor-link": "供应商链接",
    "viewing-angle": "视角"
  },
  "settings": {
    "circuit-design": {
      "enob": "ENOB: {enob} bits",
      "one-stage": "单",
      "opamp-lock": "Lock",
      "opamp-stage1": "第1级",
      "opamp-stage2": "第2级",
      "opamps": "Op Amps:",
      "opamps-tooltip": "Op Amp",
      "output-offset": "输出失调: {offset}V",
      "output-signal": "输出信号",
      "peak-voltage": "峰值电压 (V<sub>P</sub>)",
      "peak-voltage-tooltip": "Peak Voltage",
      "peaking": "峰值",
      "peaking-high": "高",
      "peaking-low": "低",
      "peaking-tooltip": "峰值",
      "quick-results": "快速结果",
      "quick-results-tooltip": "快速结果",
      "snr": "SNR: {snr} dB",
      "stages": "级数",
      "stages-tooltip": "级数",
      "target-bandwidth": "Target Bandwidth",
      "target-option-band": "带宽",
      "target-option-pulse": "脉冲宽度",
      "target-pulse-width": "目标速度",
      "target-speed-tooltip": "Speed",
      "two-stage": "双"
    },
    "next-steps": {
      "get-files": "获取文件",
      "get-files-all": "获取设计",
      "get-files-all-tooltip": "下载包含SPICE文件、BOM、评估板文件、和pdf版视图的zip文件",
      "get-files-spice": "仅SPICE",
      "get-files-spice-tooltip": "下载包含SPICE文件的zip文件",
      "mail": "邮件分享给同事",
      "mail-tooltip": "将此设计的副本发送给同事",
      "order": "订购",
      "order-samples": "申请样片",
      "order-samples-tooltip": "申请器件样片",
      "share": "共享"
    },
    "photodiode": {
      "bias-polarity-tooltip": "光电二极管偏置",
      "capacitance-1": "电容 (C<sub>D</sub>)",
      "capacitance-2": "在 VR = {vr} V",
      "capacitance-tooltip": "电容",
      "capacitance-warning": "Be careful. This is the capacitance at <u>your</u> reverse voltage, which may be different than what is specified in the datasheet table. You may need to read this value from a datasheet graph instead.",
      "or": "或",
      "peak-current": "峰值电流 (I<sub>P</sub>)",
      "peak-current-tooltip": "峰值电流",
      "photodiode-bias": "光电二极管偏置",
      "photodiode-select": "从器件库中选择光电二极管",
      "photodiode-specs": "光电二极管规格",
      "reverse-voltage": "反向电压 (V<sub>R</sub>)",
      "reverse-voltage-negative": "负",
      "reverse-voltage-positive": "正",
      "reverse-voltage-tooltip": "反向电压",
      "shunt-resistance": "分流电阻 (R<sub>SH</sub>)",
      "shunt-resistance-tooltip": "分流电阻"
    }
  },
  "units": {
    "A": "A",
    "F": "F",
    "Q": "Q",
    "R": "Ω",
    "V": "V",
    "active-area": "mm<sup>2</sup>",
    "dB": "dB",
    "farad": "F",
    "hertz": "Hz",
    "meters": "m",
    "ohm": "Ohm",
    "operating-temperature": "&deg;C",
    "peak-light-intensity": " W/m<sup>2</sup>",
    "seconds": "s",
    "sensitivity": "A/W",
    "unit-price": "$ US",
    "viewing-angle": "&deg;",
    "volts-per-amp": "V/A",
    "volts-per-volt": "V/V"
  },
  "validation-error": {
    "button-tooltip": "请先修正错误，然后继续。",
    "capacitance": "电容值必须在以下范围内：{min}至{max}",
    "invalid-input-error": "无法解析字段{field}中的值{value}。",
    "min-pulse-speed": "电容值必须在以下范围内：{min}至{max}",
    "no-opamp-found": "None found",
    "peak-current": "峰值电流必须在以下范围内：{min}至{max}",
    "peak-light-intensity": "光强度的峰值必须限制在这个范围：{min}到{max}",
    "peak-voltage": "峰值电压值必须在以下范围内：{min}至{max}",
    "reverse-voltage": "反向电压值必须在以下范围内：{min}至{max}",
    "shunt-resistance": "分流电阻值必须在以下范围内：{min}至{max}",
    "speed": "电容值必须在以下范围内：{min}至{max}"
  }
}]];